'use strict';

CapCheckbox.$inject = ["$rootScope"];
CatalogueController.$inject = ["$scope", "dialogData", "sessionData", "productDataCollector", "productDataFinalizer", "htmlTruster", "webtrekk"];
MyproductsController.$inject = ["$scope", "$routeParams", "dialogData", "sessionData", "uiservice", "productDataCollector", "htmlTruster", "webtrekk"];
OrderadministrationconfirmationController.$inject = ["$scope", "dialogData", "productDataCollector", "htmlTruster", "webtrekk"];
OrderadministrationselectionController.$inject = ["$scope", "$routeParams", "dialogData", "productDataCollector", "htmlTruster", "webtrekk"];
OrderadministrationsummaryController.$inject = ["$scope", "$routeParams", "dialogData", "uiservice", "sessionData", "productDataCollector", "orderProductTermsConfirmation", "htmlTruster", "webtrekk"];
OrderconfirmationController.$inject = ["$scope", "$routeParams", "dialogData", "sessionData", "productDataCollector", "optinProductTransformer", "htmlTruster", "webtrekk"];
OrderselectionController.$inject = ["$scope", "$window", "dialogData", "uiservice", "sessionData", "productDataCollector", "htmlTruster", "webtrekk", "$log"];
OrdersummaryController.$inject = ["$scope", "$routeParams", "$window", "dialogData", "uiservice", "sessionData", "productDataCollector", "optinProductTransformer", "orderProductTermsConfirmation", "htmlTruster", "webtrekk"];
ProductchangeconfirmationController.$inject = ["$scope", "$routeParams", "dialogData", "sessionData", "productDataCollector", "htmlTruster", "webtrekk"];
ProductchangeselectionController.$inject = ["$scope", "$routeParams", "dialogData", "sessionData", "productDataCollector", "htmlTruster", "webtrekk"];
ProductchangesummaryController.$inject = ["$scope", "$routeParams", "dialogData", "uiservice", "sessionData", "productDataCollector", "orderProductTermsConfirmation", "htmlTruster", "webtrekk"];
ProductdetailsController.$inject = ["$scope", "$routeParams", "$translate", "dialogData", "uiservice", "sessionData", "productDataCollector", "productDataFinalizer", "htmlTruster", "webtrekk"];
ReservationConfirmationController.$inject = ["$scope", "$routeParams", "dialogData", "productDataCollector", "htmlTruster", "webtrekk"];
configRoutes.$inject = ["$routeProvider"];
angular.module('substoreApp', [
    'ngSanitize',
    'ngRoute',
    'pascalprecht.translate',
    'ui.bootstrap',
    'substoreApp.filters',
    'substoreApp.services',
    'substoreApp.directives',
    'substoreApp.controllers'
])

    .config(['$translateProvider', function ($translateProvider) {
        // Load i18n message files asynchronously on demand:
        $translateProvider.useLoader('asyncI18nLoader');
        $translateProvider.preferredLanguage("de");
        $translateProvider.useMissingTranslationHandlerLog();
        $translateProvider.useMissingTranslationHandler('missingTranslation');
    }])

    .factory('missingTranslation', ["$log", function ($log) {
        var missingTranslations = {};
        return function(translationId) {
            if (!missingTranslations[translationId]) {
                missingTranslations[translationId] = true;
                $log.debug("Missing translation: ", translationId);
            }
        };
    }])

    .factory('pendingRequestsHttpInterceptor', [ '$q', '$location', '$timeout', '$log', 'sessionData', function ($q, $location, $timeout, $log, sessionData) {
        function isBlocking(config) {
            var url = config.url;
            if (typeof url !== 'string')
                url = url[0];

            //$log.debug("pendingRequestsHttpInterceptor.isBlocking", config, config && config.url, url);

            // white list for non-blocking calls
            if (url.match(".*productAvailability.*"))
                return false;

            return true;
        }

        var delayWaitAn;
        return {
            'request': function (config) {
                //$log.debug("pendingRequestsHttpInterceptor.request: ", config, config && config.url);

                if (isBlocking(config)) {
                    sessionData.transient.pendingRequests++;
                    if (delayWaitAn) {
                        $timeout.cancel(delayWaitAn);
                    }
                    delayWaitAn = $timeout(function () { //delay wait animation so its only visible for really long wait time
                        sessionData.transient.isLoading = true;
                    }, 100);
                }

                return config || $q.when(config);
            },

            'requestError': function (rejection) {
                //$log.debug("pendingRequestsHttpInterceptor.requestError: ", rejection, rejection.config, rejection.config && rejection.config.url);

                if (isBlocking(rejection.config)) {
                    sessionData.transient.pendingRequests--;
                }

                return $q.reject(rejection);
            },

            'response': function (response) {
                //$log.debug("pendingRequestsHttpInterceptor.response: ", response, response.config, response.config && response.config.url);

                if (isBlocking(response.config)) {
                    sessionData.transient.pendingRequests--;
                    if (sessionData.transient.pendingRequests === 0) {
                        $timeout.cancel(delayWaitAn);
                        sessionData.transient.isLoading = false;
                    }
                }

                return response || $q.when(response);
            },

            'responseError': function (rejection) {
                //$log.debug("pendingRequestsHttpInterceptor.responseError: ", rejection, rejection.config, rejection.config && rejection.config.url);

                if (isBlocking(rejection.config)) {
                    sessionData.transient.pendingRequests--;
                    if (sessionData.transient.pendingRequests === 0) {
                        $timeout.cancel(delayWaitAn);
                        sessionData.transient.isLoading = false;
                    }

                    //Firefox triggers the onerror callback of any pending XHR when moving away of the current page (e.g. reloading), status -1 is returned
                    // https://github.com/angular/angular.js/issues/14219
                   if (rejection.status != -1) {
                        $location.path("error");

                   }
                    return $q.reject(rejection);
                }


            }

        };
    }])

    .config(["$httpProvider", function ($httpProvider) {
        $httpProvider.interceptors.push('pendingRequestsHttpInterceptor');
    }])

    .run(['$location', '$compile', '$rootScope', '$window', '$translate', 'uiservice', 'sessionData', '$http', function ($location, $compile, $rootScope, $window, $translate, uiservice, sessionData, $http) {

        function loadTitle() {
            // 3.2.3 Page Title
            // Note: we cannot use angularjs binding for <title> element, because it doesn't work with IE8
            // Note: title is changed in the masterController.js when breadcrumb is changed
            $translate('title').then(function (title) {
                $window.document.title = title;
            });
        }

        function goErrorWithFault(code) {
            if (code)
                sessionData.fault = { code: code };
            $location.url('/error/' + sessionData.fault.code);
            $location.replace();
        }

        // make body visible
        function showBody() {
            if (self === top) {
                angular.element(document.querySelector('#bodymain')).css('display', 'inherit');
            } else {
                top.location = self.location;
            }
            loadTitle();
        }

        function handleErrorResponse(response, /*optional*/ errorInURL) {
            if (response && response.status == 500 && response.data && response.data.head && response.data.head.fault) {
                // we got a fault from server
                sessionData.fault = response.data.head.fault;
                // maybe we got a sessionId, too. (it's optional during a fault)
                sessionData.sessionId = response.data.head.sessionId;
                // and maybe we got a csrfProtectionToken, too
                if (response.data.data) {
                    sessionData.csrfProtectionToken = response.data.data.csrfProtectionToken;
                    // The /createSession and /getSession requests can even return regular dialogStaticData
                    // together with the fault (e.g. for language, natCoName, wpid etc.)
                    if (response.data.data.dialogStaticData) {
                        sessionData.mergeWith(response.data.data.dialogStaticData);
                    }
                }
                // store session data
                sessionData.storeSessionData();
                $http.defaults.headers.common['CSRF-TOKEN'] = sessionData.csrfProtectionToken;
                window.onfocus = window.onbeforeunload = sessionData.storeSessionData;
                sessionData.notifyDataAvailable();
                // display session data error
                goErrorWithFault(errorInURL);
            } else {
                // other HTTP errors
                goErrorWithFault('UNEXPECTED_ERROR');
            }
            showBody();
        }

        var cryptoticket = $location.search().ct;
        var servicepartner = $location.search().sp;
        var errorInURL = $location.search().error || ($location.path().substring(0, 7) == '/error/' ? $location.path().substring(7) : null);
        var psn = $location.search().psn;
        var page = $location.search().page;

        if (!cryptoticket) {
            // if no cryptoticket is given, then we should already have sessionData
            if (sessionData.loadSessionData() && sessionData.sessionId) {
                // Workaround: try to extract orderCallId from url if we don't have any, and put it into sessionData.transient.
                // This is a hack, because it would be better to store the orderCallId in the non-transient (persistent) part
                // of sessionData so that it survives browser reloads.
                if (!sessionData.transient.orderCallId) {
                    // 1. orderCallId could be given as search parameter. This happens if a 3rd part authentication site
                    // redirects back to us (see ReturnFromExternalRequestProcessor)
                    sessionData.transient.orderCallId = $location.search().orderCallId;
                }
                if (!sessionData.transient.orderCallId) {
                    // 2. orderCallId could be inside the Angular hash, e.g. "#/ordersummary/<subscriptionTemplateId>/<orderCallId>/<someOtherStuff>
                    var match = /\/ordersummary\/[^\/]+\/([^\/]+)/.exec($location.path());
                    if (match) sessionData.transient.orderCallId = match[1];
                }
                // call /getSession to retrieve existing session data
                uiservice.getSession({ sessionId: sessionData.sessionId, orderCallId: sessionData.transient.orderCallId, subscriptionTemplateId: sessionData.transient.subscriptionTemplateId, lang: sessionData.dialogStaticData.language, wpId: sessionData.dialogStaticData.wholesalePartnerId },
                    function success(response) {
                        // save session data
                        sessionData.sessionId = response.head.sessionId;
                        sessionData.dialogStaticData = response.data.dialogStaticData;
                        sessionData.transient.subscriptionTemplateId = response.data.subscriptionTemplateId;
                        sessionData.storeSessionData();
                        $http.defaults.headers.common['CSRF-TOKEN'] = sessionData.csrfProtectionToken;
                        window.onfocus = window.onbeforeunload = sessionData.storeSessionData;
                        sessionData.notifyDataAvailable();
                        // if parameter error has been given in URL show error even if getSession return success
                        if (errorInURL) {
                            goErrorWithFault(errorInURL);
                        }
                        $location.replace();
                        showBody();
                    },
                    function error(response) {
                        handleErrorResponse(response, errorInURL);
                    });
            } else {
                // No cryptoticket given, and session data could not be loaded: probably wrong URL parameters, or wrong state:
                // Display either persisted error, or error code given by 'error' parameter.
                // But first try to load dialogStaticData without sessionId. We need the dialogStaticData because of natCoName
                // and availableLanguages
                uiservice.getSession({ sessionId: null, orderCallId: null, subscriptionTemplateId: null, lang: sessionData.dialogStaticData.language, wpId: sessionData.dialogStaticData.wholesalePartnerId },
                    function success(response) {
                        // success() should neven been called, because the /getSession request without sessionId
                        // always returns an HTTP 500 error with fault section
                        goErrorWithFault('UNEXPECTED_ERROR');
                        showBody();
                    },
                    function error(response) {
                        // The error response should have a data fault section with code EXPIRED_SESSION
                        // (because we didn't sent a sessionId) and a data section with dialogStaticData only.
                        // This will be handled by the following method.
                        handleErrorResponse(response, errorInURL);
                    });
            }
        } else {
            uiservice.createSession({ ct: cryptoticket, sp: servicepartner, chainId: uuid.v4(), psn: psn, page: page },
                function success(response) {
                    sessionData.sessionId = response.head.sessionId;
                    sessionData.csrfProtectionToken = response.data.csrfProtectionToken;

                    // save session data
                    sessionData.dialogStaticData = response.data.dialogStaticData;
                    sessionData.transient.subscriptionTemplateId = response.data.subscriptionTemplateId;
                    // store session data
                    sessionData.storeSessionData();
                    $http.defaults.headers.common['CSRF-TOKEN'] = sessionData.csrfProtectionToken;
                    window.onfocus = window.onbeforeunload = sessionData.storeSessionData;
                    sessionData.notifyDataAvailable();

                    // further routing: respect showPage depending on current workflow
                    switch (response.data.showPage) {
                        case 'CATALOGUE' :
                            $location.path("/catalogue");
                            break;
                        case 'MYPRODUCTSPAGE' :
                            $location.path("/myproducts/" + (sessionData.transient.subscriptionTemplateId ? sessionData.transient.subscriptionTemplateId : ""));
                            break;
                        case 'PRODUCTDETAILPAGE' :
                            $location.path("/productdetails/" + sessionData.transient.subscriptionTemplateId);
                            sessionData.transient.deeplinkedPage = response.data.showPage;
                            break;
                        case 'ORDERSELECTIONPAGE' :
                            $location.path("/orderselection/" + sessionData.transient.subscriptionTemplateId);
                            break;
                        case 'OPTIN' :
                            $location.path("/ordersummary/" + sessionData.transient.subscriptionTemplateId + "/" + response.data.orderCallId + "/optin");
                            break;
                        // temporary 18.2.1 solution part #2: handle deep link for product change
                        case 'PRODUCTCHANGEPAGE' :
                            $location.path("/productchangeselection/" + sessionData.transient.subscriptionTemplateId + "/" + response.data.uniqueSubscriptionId);
                            break;
                        // end of temporary 18.2.1 solution part #2
                        default:
                            goErrorWithFault("UNEXPECTED_ERROR");
                            break;
                    }
                    // remove all url params
                    $location.search({});
                    $location.replace();
                    //show something
                    showBody();
                },
                function error(response) {
                    handleErrorResponse(response);
                }
            );
        }
    }]);

'use strict';

/* Services */

angular.module('substoreApp.services', ['ngResource', 'ngCookies']);
'use strict';

angular.module('substoreApp.services')
    .factory('asyncI18nLoader', ["$http", "$q", "uiservice", "sessionData", function ($http, $q, uiservice, sessionData) {
        return function (options) {
            var deferred = $q.defer();
            sessionData.promise.then(function () {
                // load localization files

                uiservice.i18nMessages({
                        sessionId: sessionData.sessionId,
                        lang: sessionData.dialogStaticData.language,
                        wpId: sessionData.dialogStaticData.wholesalePartnerId
                    },
                    function success(response) {
                        if (response.data && response.data.translations)
                            deferred.resolve(response.data.translations);
                        else
                            deferred.reject(options.key);
                    },
                    function error(response) {
                        deferred.reject(options.key);
                    }
                );
            });
            return deferred.promise;
        };
    }]);
'use strict';

angular.module('substoreApp.services')
    .service('dialogs', ['$uibModal', function ($uibModal) {
        return {
            /**
             * Show ok/cancel dialog.
             * @param config an object containing:
             *   - templateUrl (string, required)
             *   - data (object, optional, can be accessed as 'data' in the
             *     template)
             *   - onOk (function, optional, get's called after user presses OK
             *     button)
             */
            okcancel: function (config) {
                $uibModal.open({
                    templateUrl: 'templates/modaldialog-okcancel.html',
                    controller: ["$scope", "$modalInstance", function ($scope, $modalInstance) {
                        $scope.innerTemplateUrl = config.templateUrl;
                        $scope.data = config.data;
                        $scope.ok = function () {
                            $modalInstance.close();
                            if (config.onOk) config.onOk();
                        };
                        $scope.cancel = function () {
                            $modalInstance.close("close");
                        }
                    }]
                });
            }
        }
    }]);
'use strict';

angular.module('substoreApp.services')
    .service('emailValidationService', function () {
        // CAP-1843: valid email regex:
        // * allow exactly one '@' in the middle
        // * don't allow any whitespace
        // * don't allow '<' and '>' because of CSS vulnerability attacks
        // * don't allow '.' at start and end
        // * don't allow two consecutive '.'
        // * the parts before and after the '@' may not be larger than 999,
        //   thus totalling to a maximum length of 2000 chars (which is the
        //   maximum allowed lengths for SubSe's description elements)
        var emailRegex = /^[^\s@<>.]([^\s@<>.]|(\.(?!\.|@))){0,998}@[^\s@<>.]([^\s@<>.]|(\.(?!\.|$))){0,998}$/;

        function isValidEmail(s) {
            return s.match(emailRegex) != null;
        }

        return {
            isValid: isValidEmail
        }
    });
'use strict';

angular.module('substoreApp.services')
    .factory('$exceptionHandler', ['$injector', '$log', function ($injector, $log) {
        var $location;
        var sessionData;

        // make body visible (in case it is not already visible)
        function showBody() {
            if (self === top) {
                angular.element(document.querySelector('#bodymain')).css('display', 'inherit');
            } else {
                top.location = self.location;
            }
        }

        return function (exception, cause) {
            $location = $location || $injector.get('$location');
            sessionData = sessionData || $injector.get('sessionData');
            var targetRoute = "/error";

            // prepare arguments for error page to make exception displayable
            if (typeof exception === "object" && exception.code) {
                $log.info('exceptionHandler: handling error code exception object:');
                $log.info(exception);
                sessionData.fault = exception;
                if (exception.code === "EXPIRED_SESSION") {
                    // special case: session expired
                    sessionData.sessionId = null;
                } else if (exception.positiveError === true) {
                    // special case: positive error
                    targetRoute = "/processing";
                }
            } else {
                // we cannot determine what it is
                $log.error('exceptionHandler: unhandled Javascript exception:');
                $log.error(exception);
                if (cause) { $log.error('cause:'); $log.error(cause); }
                sessionData.fault = {
                    code: "JAVASCRIPT_EXCEPTION",
                    message: 'unhandled Javascript exception: ' + exception.toString(),
                    args: { 'exception': exception, stackTrace: exception.stack }
                };
            }

            if (exception.positiveError !== true && sessionData.fault.code) {
                targetRoute = "/error/" + sessionData.fault.code;
            }

            $location.path(targetRoute);
            showBody();
        };
    }])
    /**
     * Generic error handling method to be used by routes
     */
    .factory('throwServiceResponseFault', ["sessionData",  function(sessionData) {
        var throwServiceResponseFault = function (response) {
            if (response.data && response.data.head && response.data.head.fault) {
                sessionData.fault = response.data.head.fault;
                throw sessionData.fault;
            } else if (response.status != -1) { //Firefox triggers the onerror callback of any pending XHR when moving away of the current page (e.g. reloading), status -1 is returned
                                                // https://github.com/angular/angular.js/issues/14219
                // no fault from server
                throw {
                    code: "HTTP_" + response.status,
                    message: "HTTP service request failed with " + response.status + " on " + response.config.method + " " + response.config.url,
                    config: response.config
                };
            }
        };

        return throwServiceResponseFault;
    }]);
(function() {
    'use strict';

    angular.module('substoreApp.services')

        /**
         * Trust the following fields because we want to allow iframes, etc.
         *
         * Created by Mark von Zeschau on 31.08.2015
         */
        .factory('htmlTruster', ['$sce',
            function ($sce) {
                // please keep this list sorted alphabetically
                var fieldsToTrust = [
                    'accountInfoTextOptinSummary',
                    'afterOptinInfoText',
                    'beforeOptinInfoText',
                    'cataloguePromotionDisruptorText',
                    'catalogueRegularDisruptorText',
                    'dataTransferDenialText',
                    'descriptionAdministrationSelection',
                    'descriptionAdministrationSummary',
                    'emailTextProductChangeSummary',
                    'emailTextProductOrder',
                    'hintDescriptionAdministrationSelection',
                    'hintMyProducts',
                    'linkDescriptionAdministrationSummary',
                    'linkInfoText',
                    'linkInfoTextAdministrationSummary',
                    'minimumCommitmentPeriodOverrideText',
                    'minimumCommitmentPeriodOverrideTextMyProducts',
                    'minimumCommitmentPeriodText',
                    'minimumCommitmentPeriodTextMyProducts',
                    'orderCancellationDateQuestion',
                    'orderCancellationQuestion',
                    'orderCancellationConfirmButtonLabel',
                    'orderCancellationAbortButtonLabel',
                    'orderCancellationSucceeded',
                    'orderReactivationQuestion',
                    'orderReactivationSucceeded',
                    'orderReservationDeletionQuestion',
                    'orderReservationDeletionSucceeded',
                    'orderTerminationQuestion',
                    'orderTerminationSucceeded',
                    'parameterValueMyProducts',
                    'priceInformation',
                    'productAdministrationConfirmation',
                    'productAdministrationConfirmationHint',
                    'productChangeConfirmation',
                    'productChangeConfirmationAfterButtons',
                    'productChangeConfirmationBeforeButtons',
                    'productConfirmation',
                    'productConfirmationAfterButtons',
                    'productConfirmationBeforeButtons',
                    'productDescriptionCatalogue',
                    'productDescriptionChangeSelection',
                    'productDescriptionChangeSummary',
                    'productDescriptionDetails',
                    'productDescriptionOptinSummary',
                    'productDescriptionSelection',
                    'productDescriptionSummary',
                    'productGroupLowerDescriptionDetails',
                    'productGroupSelectionLabelDetails',
                    'productGroupUpperDescriptionDetails',
                    'productName',
                    'productOptinConfirmation',
                    'productOptinConfirmationAfterButtons',
                    'productOptinConfirmationBeforeButtons',
                    'productRequirementsDetails',
                    'productSubscriptionType',
                    'promotionPriceOverrideText',
                    'providerName',
                    'redirectHint',
                    'regularPriceOverrideText',
                    'reservationHint',
                    'textToBeConfirmedAdministrationSummary',
                    'textToBeConfirmedChangeSummary',
                    'textToBeConfirmedOptinSummary',
                    'textToBeConfirmedSummary'
                ];

                var trustInternal = function (wrapper, field) {
                    var text = wrapper[field];
                    if (text != null && (typeof text === 'string')) {
                        wrapper[field] = $sce.trustAsHtml(text);
                    }
                };

                var trust = function (textsWrapper, propertyName) {
                    if (propertyName == null) {
                        propertyName = 'texts';
                    }
                    for (var i = 0; i < fieldsToTrust.length; i++) {
                        var fieldToTrust = fieldsToTrust[i];
                        if (textsWrapper.length !== undefined) {
                            for (var j = 0; j < textsWrapper.length; j++) {
                                trustInternal(textsWrapper[j][propertyName], fieldToTrust);
                            }
                        } else {
                            trustInternal(textsWrapper[propertyName], fieldToTrust);
                        }
                    }
                };

                return {
                    trust: trust
                };

            }
        ]);
})();

'use strict';

angular.module('substoreApp.services')
    .service('optinProductTransformer', [function () {
        /** optin dialogs for order summary and order confirmation are identical in structure
         * to ordinary dialogs for order summary and order confirmation. Also, within
         * subscription template product content the optin dialogs contain fields having
         * same names and referencing correlated content as ordinary dialogs but tagged
         * with an additional keyword 'Optin'.
         * This transformer copies each tagged field to a field having a name w/o the keyword,
         * e.g. headerSubTitleOptinConfirmation is copied to eaderSubTitleConfirmation
         */
        return {
            transform: function(product, keyword) {

                function strip(propertyType) {
                    var object = product[propertyType];

                    angular.forEach(object, function(value, key) {
                        var i = key.indexOf(keyword);
                        if (i > -1) {
                            var newKey = key.replace(keyword, '');
                            object[newKey] = value;
                        }
                    });
                }

                angular.forEach(product.textLists, function(textList, key) {
                    var texts = [];
                    angular.forEach(textList, function(text) {
                        if (text)
                            texts.push(text);
                    });

                    product.textLists[key] = texts;
                });

                angular.forEach(["buttons", "footnotes", "hyperlinks", "images", "textLists", "texts"], strip);

                return product;
            }
        }

    }]);
'use strict';

angular.module('substoreApp.services')
    .factory('orderProductTermsConfirmation', [ 'emailValidationService', function(emailValidationService) {
        var maxTextsToBeConfirmed = 10; // we do not support more than 10 texts to be confirmed

        function arrayOfBoolean(value) {
            var array = [];
            for (var i = 0; i < maxTextsToBeConfirmed; i++) // no, we cannot use Array.map because of IE8
                array[i] = value;
            return array;
        }

        function allTrue(values) {
            for (var i = 0; i < values.length; i++)
                if (!values[i])
                    return false;
            return true;
        }

        function setBoolArray(textToBeConfirmed, okAcceptTextToBeConfirmed, focusAcceptTextToBeConfirmed, acceptTextToBeConfirmed, focusSet) {
            for (var i = 0; i < textToBeConfirmed.length; i++) {
                okAcceptTextToBeConfirmed[i] = acceptTextToBeConfirmed[i];
                if(!okAcceptTextToBeConfirmed[i] && !focusSet) {
                    focusSet = focusAcceptTextToBeConfirmed[i] = true;
                }
            }
        }

        return function() {
            return {
                acceptTerms: false,
                acceptTextToBeConfirmed: arrayOfBoolean(false),
                acceptTextToBeConfirmedChange: arrayOfBoolean(false),
                acceptRescissionRights: false,
                customerEmail: undefined,
                customerVerificationEmail: undefined,
                emailVerification: false,
                ok: { acceptTerms: true, acceptTextToBeConfirmed: arrayOfBoolean(true), acceptTextToBeConfirmedChange: arrayOfBoolean(true), acceptRescissionRights: true, customerEmail: true, customerVerificationEmail: true },
                focus:  { acceptTerms: false, acceptTextToBeConfirmed: arrayOfBoolean(false), acceptTextToBeConfirmedChange: arrayOfBoolean(false), acceptRescissionRights: false, customerEmail: false, customerVerificationEmail: false },
                focusSet: false,
                failed: function (termsOrderLink, rescissionOrderLink, textToBeConfirmed, textToBeConfirmedChange, emailTextProductOrder) {
                    this.focusSet = false;

                    this.ok.acceptTerms = (!termsOrderLink || this.acceptTerms);
                    if(!this.ok.acceptTerms && !this.focusSet) this.focusSet = this.focus.acceptTerms = true;
                    this.ok.acceptRescissionRights = (!rescissionOrderLink || this.acceptRescissionRights);
                    if(!this.ok.acceptRescissionRights && !this.focusSet) this.focusSet = this.focus.acceptRescissionRights = true;

                    if ( textToBeConfirmedChange ) {
                        setBoolArray(textToBeConfirmedChange, this.ok.acceptTextToBeConfirmedChange, this.focus.acceptTextToBeConfirmedChange, this.acceptTextToBeConfirmedChange, this.focusSet);
                    }
                    if ( textToBeConfirmed ) {
                        setBoolArray(textToBeConfirmed, this.ok.acceptTextToBeConfirmed, this.focus.acceptTextToBeConfirmed, this.acceptTextToBeConfirmed, this.focusSet);
                    }

                    this.ok.customerEmail = (!emailTextProductOrder || ((this.customerEmail && emailValidationService.isValid(this.customerEmail))));
                    if(!this.ok.customerEmail && !this.focusSet) {
                        this.focusSet = this.focus.customerEmail = true;
                    }

                    this.ok.customerVerificationEmail = (!this.emailVerification || (this.customerEmail==this.customerVerificationEmail));
                    if(!this.ok.customerVerificationEmail && !this.focusSet) {
                        this.focusSet = this.focus.customerVerificationEmail = true;
                    }

                    return (!(this.ok.acceptTerms && this.ok.acceptRescissionRights && allTrue(this.ok.acceptTextToBeConfirmed) && allTrue(this.ok.acceptTextToBeConfirmedChange) && this.ok.customerEmail && this.ok.customerVerificationEmail));
                }
            }
        }
    } ]);
'use strict';

angular.module('substoreApp.services')
    .service('partnerFeatureRegistry', ['$injector', function ($injector) {

        var registry = {
            templates: {},
            actions: {}
        };

        var features = {};

        function preparePath(path) {
            var featureId = path[0];
            if (!featureId)
                return;

            // get feature service by normalized name if not already tried
            var featureId_ = featureId.toLowerCase();
            var feature = features[featureId_];
            if (!feature && (feature !== null)) {
                var serviceId = 'partnerFeature' + featureId.charAt(0).toUpperCase() + featureId.slice(1).toLowerCase();

                if ($injector.has(serviceId)) {
                    feature = features[featureId_] || $injector.get(serviceId);

                    registry.templates[featureId_] = feature.templates;
                    registry.actions[featureId_] = feature.actions;

                } else
                    features[featureId_] = null;
            }
        }

        function lookup(registry, path) {
            if (!path.length)
                return undefined;

            preparePath(path);

            var target = registry;
            for (var i = 0; i < path.length; i++) {
                if (!target)
                    return undefined;

                var arg = path[i];
                if (!arg)
                    return undefined;

                if (typeof arg !== 'string')
                    throw "illegal arguments to call of partnerFeatureRegistry (element #" + i + " on path): " + path;

                target = target[arg.toLowerCase()];
            }

            return target;
        }

        return {
            applyWithScope: function (scope, path) {
                var fn = lookup(registry.actions, path);
                if (fn === undefined)
                    return true; // no target service found; return true to signal success
                else if (typeof fn === 'function')
                    return fn(scope);
                else
                    return fn;
            },
            lookupTemplate: function (path) {
                return lookup(registry.templates, path);
            }
        };
    }]);
'use strict';

angular.module('substoreApp.services')
    .service('productDataCollector', [function () {
        /**
         * Collect some data from product description. The services delivering
         * product data do extensively use array for text and image properties.
         * Those properties hardly to display by NG expressions are collected
         * from the product description arrays and stored as regular properties
         * in the product.
         * This function is destructive as it modifies the given product
         * instance.
         */

        function reorderGalleryImages(images) {
            // because imageIds are ordinals not guaranteed to be dense as well as they
            // increment across all translation languages imageIds might have to be normalized
            var collections = {
                imageGallery: [],
                thumbnailGallery: []
            };
            // first: collect both relevant kinds of images
            angular.forEach(images, function(image) {
                if (collections[image.name] !== undefined)
                    collections[image.name][image.imageId] = image;
            });
            // second: reorder images of both collection
            angular.forEach(collections, function(collection) {
                for (var i = 0, j = 0; i < collection.length; i++)
                    if (collection[i])
                        collection[i].imageId = ++j;
            });
        }

        return {
            collect: function (product) {
                return this._collect(product, false);
            },
            collectWithGallery: function (product) {
                return this._collect(product, true);
            },
            _collect: function (product, withGallery) {

                product.texts = {};
                product.images = {};
                product.gallery = {};
                product.hyperlinks = {};

                var textsCount = product.productDescription.texts.length;
                if (textsCount > 0) {
                    var texts = {};
                    for (var i = 0; i < textsCount; i++) {
                        var tuple = product.productDescription.texts[i];
                        texts[tuple.name] = tuple.text;
                    }
                    product.texts = texts;
                }

                var textLists = {};
                angular.forEach(product.productDescription.textLists, function(value, key) {
                    textLists[key] =  [];
                    for (var i = 0; i < value.length; i++)
                        textLists[key].push(value[i].text);
                });
                product.textLists = textLists;

                var imagesCount = product.productDescription.images.length;
                if (imagesCount > 0) {
                    var images = {};
                    var gallery = [];
                    if (withGallery)
                        reorderGalleryImages(product.productDescription.images);

                    for (var i = 0; i < imagesCount; i++) {
                        var tuple = product.productDescription.images[i];
                        var isGallery = (tuple.name === 'imageGallery' || tuple.name === 'thumbnailGallery');
                        if (withGallery && isGallery) {
                            var imageId = tuple.imageId;
                            var galleryItem = gallery[imageId - 1];
                            if (!galleryItem)
                                galleryItem = gallery[imageId - 1] = {};

                            galleryItem[tuple.name] = {
                                alt: tuple.alt,
                                resourcePath: tuple.resourcePath
                            }
                        } else {
                            images[tuple.name + "Alt"] = tuple.alt;
                            images[tuple.name + "ResourcePath"] = tuple.resourcePath;
                        }
                    }
                    product.images = images;
                    if (withGallery)
                        product.gallery = gallery;
                }

                var hyperlinksCount = product.productDescription.hyperlinks.length;
                if (hyperlinksCount > 0) {
                    var hyperlinks = {};
                    for (var i = 0; i < hyperlinksCount; i++) {
                        var tuple = product.productDescription.hyperlinks[i];
                        hyperlinks[tuple.name + "DisplayName"] = tuple.displayName;
                        hyperlinks[tuple.name + "Url"] = tuple.url;
                    }
                    product.hyperlinks = hyperlinks;
                }

                return product;
            }
        }
    }]);
'use strict';

angular.module('substoreApp.services')
    .service('productDataFinalizer', ['uiservice', 'sessionData', function (uiservice, sessionData) {
        /**
         * Depending on actual product state this service might perform some asynchronous finalization tasks.
         * Currently there is only one task implemented: check availability for given product. Because max
         * number of outstanding ajax requests is assumed to be limited, this service provides internal
         * hash maps of products already in check, trying to check each product only once.
         */
        var productsPendingActive = {};
        var productsPendingPassive = [];

        var self = {
            hasUndefinedAvailability: function (product) {
                return (product.productAvailability === 'undefinedAvailability');
            },
            hasNoneAvailability: function (product) {
                return (product.productAvailability === 'noneAvailability');
            },
            isAvailable: function (product) {
                return (!(this.hasUndefinedAvailability(product) || this.hasNoneAvailability(product)));
            },
            checkAvailability: function (product) {
                if (this.hasUndefinedAvailability(product)) {
                    var invokeVerification = !productsPendingActive[product.subscriptionTemplateId];

                    if (invokeVerification) {
                        var subscriptionTemplateId = product.subscriptionTemplateId;
                        productsPendingActive[subscriptionTemplateId] = product;

                        uiservice.getProductAvailability({
                                sessionId: sessionData.sessionId,
                                subscriptionTemplateId: subscriptionTemplateId
                            },
                            function (response) {
                                productsPendingActive[subscriptionTemplateId] = null;
                                if (!response.fault) {
                                    var productAvailability = response.data.productAvailability;
                                    product.productAvailability = productAvailability;
                                    if (self.hasNoneAvailability(product))
                                        product.overrideOrderButtonText = 'product_unavailable';
                                    if (!self.hasUndefinedAvailability(product)) {
                                        for (var i = productsPendingPassive.length - 1; i >= 0; i--) {
                                            var productPending = productsPendingPassive[i];
                                            if (productPending.subscriptionTemplateId === subscriptionTemplateId && self.hasUndefinedAvailability(productPending)) {
                                                productPending.productAvailability = productAvailability;
                                                if (self.hasNoneAvailability(productPending))
                                                    productPending.overrideOrderButtonText = 'product_unavailable';
                                                productsPendingPassive.splice(i, 1);
                                            }
                                        }
                                    }
                                }
                            }
                        );
                    } else {
                        productsPendingPassive.push(product);
                    }
                }
            }
        };

        return self;
    }]);
'use strict';

angular.module('substoreApp.services')
    .service('progressBar', [function () {
        /**
         * Model of progress bar for order processing views and others.<br/>
         * It is used in several view sequences to show the progress of current processing state, e.g. ordering. It
         * has to be configured by each view to correctly reflect actual progress. However, it does not show the
         * progress itself, but it holds state and implements some business rules.<br/>
         * The model provides the following methods:
         * <ul>
         *     <li>
         *         reset() - reset the model to undefined. This should be called if view is part of processing chain,
         *         but cannot currently determine in which state it is (e.g. in between controller setup before calling
         *         ui service to retrieve actual state). A visual element never should show any progress unless it is
         *         in defined state.
         *     </li>
         *     <li>
         *         setup(config) - setup the model to defined state using parameter <i>config</i> as configuration map.
         *         Required to called by any other method but reset(). Currently the following keys are supported to configure:
         *         <li>
         *             step - mandatory ordinal number of current processing step. This might be adjusted internally because of business rules.
         *         </li>
         *         <li>
         *             administration - optional boolean flag if this is an administration process. Defaults to false and defines labels returned
         *             by getSteps()
         *         </li>
         *         <li>
         *             isOnlyReservationAllowed - optional boolean flag if this is partial process. Defaults to false and defines labels returned
         *             by getSteps() as well as total number of steps
         *         </li>
         *         <li>
         *             isPurchaseRedirectRequired - optional boolean flag if this is partial process. Defaults to false and defines labels returned
         *             by getSteps() as well as total number of steps
         *         </li>
         *         <li>
         *             thirdPartyAuthentication - optional boolean flag if this is an extended process by third party authentication. Defaults to false
         *             and defines labels returned by getSteps() as well as total number of steps
         *         </li>
         *         <li>progressBarEnabled - progress bar is enabled by default. Passing "false" to this parameter hides the progress bar. Pay attention
         *             that it does not suffice to pass a falsy argument in all cases
         *         </li>
         *         <li>
         *             optin - optional boolean flag if this is an optin process. Defaults to false and defines labels returned by getSteps() as well
         *             as total number of steps
         *         </li>
         *         <li>
         *             hideSelection - optional boolean flag if the selection page is hidden (skipped). Defaults to false and defines labels returned
         *             by getSteps() as well as total number of steps
         *         </li>
         *     </li>
         *     <li>
         *         getSteps() - returns an array of labels with actual processing steps. Returns undefined if setup() was not called recently
         *     </li>
         *     <li>
         *         getStep() - returns ordinal number of current processing step. This can differ to the step passed to setup() because of
         *         business rules. Returns undefined if setup() was not called recently
         *     </li>
         * </ul>
       **/
        var steps = undefined;
        var step = undefined;

        return {
            config: undefined,
            reset: function() {
                this.config = undefined;

                steps = undefined;
                step = undefined;
            },
            setup: function(config) {
                this.reset();

                this.config = config;
            },
            getSteps: function() {
                if (!this.config)
                    return undefined;

                if (steps)
                    return steps;

                steps = [];

                if (!this.config.optin && !this.config.hideSelection)
                    steps.push(this.config.administration ? "administration" : "selection");

                if (!(this.config.isOnlyReservationAllowed || this.config.isPurchaseRedirectRequired)) {
                    if (this.config.thirdPartyAuthentication && !this.config.optin)
                        steps.push("account");

                    steps.push((this.config.optin ? "optin_" : "") + "summary");
                }

                steps.push((this.config.optin ? "optin_" : "") + "confirmation");

                return steps;
            },
            getStep: function() {
                if (!this.config)
                    return undefined;

                if (step)
                    return step;

                if (this.config.optin || this.config.hideSelection)
                    step = this.config.step - 1;

                if (!step) {
                    step = this.config.step;
                    if (step > 1 && this.config.thirdPartyAuthentication)
                        ++step;
                    else
                    // pay attention to this idiom: so far the authentication
                    // page (if any) does not come with it's own step number
                    // so we know it is always "2"
                    if (!step)
                        step = 2;
                }

                return step;
            }
        };
    }]);
'use strict';

angular.module('substoreApp.services')
/**
 * return promise immediately. This is a convenience function simplifying
 * code which is urged to return promises but does not really need it
 */
    .service('promiseImmediately', ['$q', function ($q) {
        return function () {
            var deferred = $q.defer();
            var promise = deferred.promise;
            deferred.resolve();
            return promise;
        };
    }]);
(function() {
    'use strict';

    sessionDataService.$inject = ["$q", "$cookies", "$log"];
    angular.module('substoreApp.services')
        .service('sessionData', sessionDataService);

    var data = null;

    function sessionDataService($q, $cookies, $log) {

        var deferred = $q.defer();
        data = data || {
            sessionId: null,
            csrfProtectionToken: null,
            dialogStaticData: {
                language: null,
                availableLanguages: null,
                showCatalogue: null,
                showMyProducts: null,
                exemptedFromTax: null,
                invokingPortal: null,
                identifierType: null,
                msisdn: null,
                natCoName: null,
                wholesalePartnerId: null,
                dev: null,
                customResources: null,
                enableWebtrekkIntegration: false,
                webtrekkTealiumURL: null
            },
            fault: null,
            promise: deferred.promise,
            transient: {
                pendingRequests: 0,
                isLoading: false,
                orderCallId: null,
                subscriptionTemplateId: null,
                deeplinkedPage: null
            },
            notifyDataAvailable: function () {
                deferred.resolve(true)
            },
            hasFault: function () {
                return data.fault && data.fault.code;
            },
            resetFault: function () {
                data.fault = null;
            },
            storeSessionData: function () {
                var storedData = {
                    sessionId: data.sessionId,
                    csrfProtectionToken: data.csrfProtectionToken,
                    lang: data.dialogStaticData ? data.dialogStaticData.language : null,
                    wpId: data.dialogStaticData ? data.dialogStaticData.wholesalePartnerId : null,
                };
                $cookies.putObject("dtag-cap-substore", storedData, {path: '/'});
            },
            loadSessionData: function () {
                var storedData = $cookies.getObject("dtag-cap-substore", {path: '/'});
                if (storedData) {
                    data.sessionId = storedData.sessionId;
                    data.csrfProtectionToken = storedData.csrfProtectionToken;
                    if (!data.dialogStaticData) data.dialogStaticData = {};
                    data.dialogStaticData.language = storedData.lang;
                    data.dialogStaticData.wholesalePartnerId = storedData.wpId;
                    return true;
                } else {
                    return false;
                }
            },
            deleteSessionData: function () {
                data.sessionId = undefined;
                data.dialogStaticData = undefined;
                this.deleteCurrentSubscription();
                this.storeSessionData();
            },
            deleteCurrentSubscription: function () {
                data.transient.subscriptionTemplateId = undefined;
                data.transient.orderCallId = undefined;
            },
            mergeWith: function (newData) {
                if (!data.dialogStaticData.language) data.dialogStaticData.language = newData.language;
                if (!data.dialogStaticData.availableLanguages) data.dialogStaticData.availableLanguages = newData.availableLanguages;
                if (!data.dialogStaticData.natCoName) data.dialogStaticData.natCoName = newData.natCoName;
                if (!data.dialogStaticData.wholesalePartnerId) data.dialogStaticData.wholesalePartnerId = newData.wholesalePartnerId;
                if (!data.dialogStaticData.dev) data.dialogStaticData.dev = newData.dev;
                if (!data.dialogStaticData.customResources) data.dialogStaticData.customResources = newData.customResources;
                if (!data.dialogStaticData.enableWebtrekkIntegration) data.dialogStaticData.enableWebtrekkIntegration = newData.enableWebtrekkIntegration;
                if (!data.dialogStaticData.webtrekkTealiumURL) data.dialogStaticData.webtrekkTealiumURL = newData.webtrekkTealiumURL;
                if (!data.dialogStaticData.showMyProducts) data.dialogStaticData.showMyProducts = newData.showMyProducts;
                if (!data.dialogStaticData.showCatalogue) data.dialogStaticData.showCatalogue = newData.showCatalogue;
                if (!data.dialogStaticData.exemptedFromTax) data.dialogStaticData.exemptedFromTax = newData.exemptedFromTax;
                if (!data.dialogStaticData.invokingPortal) data.dialogStaticData.invokingPortal = newData.invokingPortal;
                if (!data.dialogStaticData.invokingPortalKey) data.dialogStaticData.invokingPortalKey = newData.invokingPortalKey;
                if (!data.dialogStaticData.msisdn) data.dialogStaticData.msisdn = newData.msisdn;
                if (!data.dialogStaticData.identifierType) data.dialogStaticData.identifierType = newData.identifierType;
                if (!data.dialogStaticData.identifiertValuePrefix) data.dialogStaticData.identifiertValuePrefix = newData.identifiertValuePrefix;
                if (!data.dialogStaticData.hideIdentifierValue) data.dialogStaticData.hideIdentifierValue = newData.hideIdentifierValue;
            },
            log: function () {
                this.sessionId && $log.debug("sessionData.sessionId=" + this.sessionId);
                this.dialogStaticData && $log.debug("sessionData.dialogStaticData=" + this.dialogStaticData);
                this.fault && $log.debug("sessionData.fault=" + this.fault);
                this.transient.pendingRequests && $log.debug("sessionData.transient.pendingRequests=" + this.transient.pendingRequests);
                this.transient.isLoading && $log.debug("sessionData.transient.isLoading=" + this.transient.isLoading);
                this.transient.orderCallId && $log.debug("sessionData.transient.orderCallId=" + this.transient.orderCallId);
                this.transient.subscriptionTemplateId && $log.debug("sessionData.transient.subscriptionTemplateId=" + this.transient.subscriptionTemplateId);
            }
        };
        return data;
    }
})();
'use strict';

angular.module('substoreApp.services')
    .factory('uiservice', ['$resource', 'sessionData', function ($resource, sessionData) {
        return $resource('../../uiservice/:methodName?t=:cacheSlayer',
            {
                cacheSlayer: function () {
                    return (new Date().getTime() + Math.random()).toString(16);
                }
            },
            {
                createSession: {
                    method: 'POST',
                    params: {methodName: 'createSession'}
                },
                getSession: {method: 'GET', params: {methodName: 'getSession'}},
                catalogueDialogData: {
                    method: 'GET',
                    params: {methodName: 'catalogueDialogData'}
                },
                deleteSession: {
                    method: 'POST',
                    params: {methodName: 'deleteSession'}
                },
                productDetailsDialogData: {
                    method: 'GET',
                    params: {methodName: 'productDetailsDialogData'}
                },
                orderSelectionDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderSelectionDialogData'}
                },
                subscriptionBegin: {
                    method: 'POST',
                    params: {methodName: 'subscriptionBegin'}
                },
                orderSummaryDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderSummaryDialogData'}
                },
                forgetAuthentication: {
                    method: 'POST',
                    params: {methodName: 'forgetAuthentication'}
                },
                subscriptionCancel: {
                    method: 'POST',
                    params: {methodName: 'subscriptionCancel'}
                },
                subscriptionBook: {
                    method: 'POST',
                    params: {methodName: 'subscriptionBook'}
                },
                orderConfirmationDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderConfirmationDialogData'}
                },
                reservationConfirmationDialogData: {
                    method: 'GET',
                    params: {methodName: 'reservationConfirmationDialogData'}
                },
                orderFormGeneration: {
                    method: 'GET',
                    params: {methodName: 'orderFormGeneration'}
                },
                myProductsOverviewDialogData: {
                    method: 'GET',
                    params: {methodName: 'myProductsOverviewDialogData'}
                },
                myProductsAction: {
                    method: 'POST',
                    params: {methodName: 'myProductsAction'}
                },
                productChangeSelectionDialogData: {
                    method: 'GET',
                    params: {methodName: 'productChangeSelectionDialogData'}
                },
                productChangeSummaryDialogData: {
                    method: 'GET',
                    params: {methodName: 'productChangeSummaryDialogData'}
                },
                productChangeAction: {
                    method: 'POST',
                    params: {methodName: 'productChangeAction'}
                },
                productChangeConfirmationDialogData: {
                    method: 'GET',
                    params: {methodName: 'productChangeConfirmationDialogData'}
                },
                orderAdministrationDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderAdministrationDialogData'}
                },
                orderAdministrationSummaryDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderAdministrationSummaryDialogData'}
                },
                orderAdministrationAction: {
                    method: 'POST',
                    params: {methodName: 'orderAdministrationAction'}
                },
                orderAdministrationConfirmationDialogData: {
                    method: 'GET',
                    params: {methodName: 'orderAdministrationConfirmationDialogData'}
                },
                getProductAvailability: {
                    method: 'GET',
                    params: {methodName: 'productAvailability'}
                },
                userCreation: {
                    method: 'POST',
                    params: {methodName: 'userCreation'}
                },
                faultMessage: {
                    method: 'GET',
                    params: {methodName: 'faultMessage'}
                },
                productDetailsAction: {
                    method: 'POST',
                    params: {methodName: 'productDetailsAction'}
                },
                i18nMessages: {
                    method: 'GET',
                    params: {methodName: 'i18nMessages'}
                },
                setLanguage: {
                    method: 'GET',
                    params: {methodName: 'setLanguage'}
                }
            }
        );
    }]);
'use strict';

angular.module('substoreApp.services')
    .service('umlautTranslator', function () {
        return function (s) {
            return s
                .replace(/Â|À|Å|Ã/g, "A")
                .replace(/â|à|å|ã/g, "a")
                .replace(/Ä/g, "AE")
                .replace(/ä/g, "ae")
                .replace(/Ç/g, "C")
                .replace(/ç/g, "c")
                .replace(/É|Ê|È|Ë/g, "E")
                .replace(/é|ê|è|ë/g, "e")
                .replace(/Ó|Ô|Ò|Õ|Ø/g, "O")
                .replace(/ó|ô|ò|õ/g, "o")
                .replace(/Ö/g, "OE")
                .replace(/ö/g, "oe")
                .replace(/Š/g, "S")
                .replace(/š/g, "s")
                .replace(/ß/g, "ss")
                .replace(/Ú|Û|Ù/g, "U")
                .replace(/ú|û|ù/g, "u")
                .replace(/Ü/g, "UE")
                .replace(/ü/g, "ue")
                .replace(/Ý|Ÿ/g, "Y")
                .replace(/ý|ÿ/g, "y")
                .replace(/Ž/g, "Z")
                .replace(/ž/, "z");
        };
    });
'use strict';

angular.module('substoreApp.services')
    .service('webtrekk', ['$rootScope', 'sessionData', 'umlautTranslator', '$q', 'asyncI18nLoader', '$filter', '$log',
        function ($rootScope, sessionData, umlautTranslator, $q, asyncI18nLoader, $filter, $log) {
            var loader = null;
            var utag_data = null;
            var first_call = true;

            return {
                track: function (page_content_suffix, data) {
                    var deferred = $q.defer();

                    function init() {
                        if (loader != null) return loader;
                        loader = $q.defer();
                        $.getScript(sessionData.dialogStaticData.webtrekkTealiumURL, function (data2, textStatus, jqxhr) {
                            if (jqxhr.status) {
                                loader.resolve();
                            } else {
                                loader.reject();
                            }
                        });
                        return loader;
                    }

                    function htmlDecode(text) {
                        // decodes html entities such as '&auml;' back to 'ä' etc.
                        // see http://stackoverflow.com/questions/10715801/javascript-decoding-html-entities
                        return $("<div/>").html(text).text();
                    }

                    function simplify(text) {
                        return umlautTranslator(htmlDecode(text))
                            .toLowerCase()
                            .replace(/[ ]+/g, "-")
                            .replace(/[^a-z0-9_-]/g, "");
                    }

                    sessionData.promise.then(function () {
                        if (sessionData.dialogStaticData.enableWebtrekkIntegration) {
                            var page_content_id = window.location.host;
                            page_content_id += "." + simplify($filter('i18n')('webtrekk_invokingportal_all'));// + simplify(sessionData.dialogStaticData.invokingPortalKey);
                            page_content_id += "." + simplify($filter('i18n')('webtrekk_' + page_content_suffix));

                            if (typeof data['page_content_id'] != 'undefined') {
                                data['page_content_id'] = page_content_id + '.' + simplify(data['page_content_id']);
                            } else {
                                data['page_content_id'] = page_content_id;
                            }

                            if (typeof data['page_type'] == 'undefined') {
                                data['page_type'] = 'basket';
                            }

                            if (typeof data['shop_product_name'] != 'undefined') {
                                data['shop_product_name'] = htmlDecode(data['shop_product_name'].toString());
                            }

                            $log.info("web tracking data for " + page_content_suffix + ":");
                            $log.info(data);

                            if (!utag_data) {
                                utag_data = document.createElement('script');
                                utag_data.setAttribute('type', 'text/javascript');
                                utag_data.innerHTML = 'var utag_data = ' + JSON.stringify(data) + ';';
                                document.body.appendChild(utag_data);
                            }

                            init().promise.then(function () {
                                if (!first_call) {
                                    utag.view(data);
                                }
                                first_call = false;
                                deferred.resolve(true);
                            });
                        } else {
                            deferred.resolve(true);
                        }
                    });

                    return deferred;
                }
            };
        }]);
'use strict';

angular.module('substoreApp.directives', []);
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to perform action on click as well as on enter key for buttons AND
 * anchors
 */
    .directive('capAction', ['$parse', function ($parse) {
        return function (scope, element, attr) {
            // get directive value (expected to be a function call)
            var fn = $parse(attr['capAction']);

            // build handler to invoke function call
            var handler = function (event) {
                scope.$apply(function () {
                    fn(scope, {$event: event})
                });
            };

            // bind handler to elements as needed
            element.bind('click', handler);
            element.bind('keyup', function (event) {
                if (event.keyCode == 13 || event.keyCode == 32)
                    handler(event);
            })
        }
    }]);
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print catalogue product
 */
    .directive('capCatalogueProduct', ['productDataFinalizer', function (productDataFinalizer) {
        return {
            restrict: 'A',
            scope: {
                p: "=product"
            },
            link: function (scope, el, attr) {
                scope.hasUndefinedAvailability = function (product) {
                    return (product.productAvailability === 'undefinedAvailability');
                };

                scope.hasNoneAvailability = function (product) {
                    return (product.productAvailability === 'noneAvailability');
                };

                scope.isAvailable = function (product) {
                    return (!(scope.hasUndefinedAvailability(product) || scope.hasNoneAvailability(product)));
                };
            },
            templateUrl: "templates/catalogueproduct.html"
        }
    }]);
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print catalogue price
 */
    .directive('capCatalogueProductPrice', function () {
        return {
            restrict: 'A',
            scope: {
                promotionProcessing: "=",
                overrideTextRegular: "=",
                overrideTextPromotion: "=",
                price: "="
            },
            templateUrl: "templates/catalogueproductprice.html"
        }
    });
'use strict';

angular.module('substoreApp.directives')

/**
 * Directive which implements a Telekom styled checkbox with some additional features
 *
 * TODO hs
 */

angular
    .module('substoreApp.directives')
    .directive('capCheckbox', CapCheckbox);

function CapCheckbox($rootScope) {
    return {
        restrict: 'EA',
        scope: {
            ngModel:     '=ngModel',
            ngRequired:  '=ngRequired',
            label:       '=capCheckboxLabel',
            hint:        '=capCheckboxHint',
            hintVisible: '=capCheckboxHintVisible',
            colSpans:    '=capCheckboxColSpans'
        },
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {
            scope.ctrl = scope; // looking forward to ng1.5 components
            scope.ctrl.isRequired = attrs.hasOwnProperty('ngRequired') ? scope.ngRequired : attrs.hasOwnProperty('required');

            var checkboxElement = element.find("div[role='checkbox']");

            // propagate aria stuff down to checkbox
            angular.forEach(["aria-label", "aria-labelledby"], function (property) {
                var normalizedProperty = attrs.$normalize(property);
                if (attrs.hasOwnProperty(normalizedProperty))
                    checkboxElement.attr(property, attrs[normalizedProperty]);
            });

            checkboxElement.bind('keyup', function (event) {
                if (event.keyCode == 13 || event.keyCode == 32) {
                    // transclusion might have injected more potential targets, so we
                    // have to check if event is dedicated to our checkbox itself
                    var targetInput = $(event.target).find('input')[0];
                    if (targetInput && targetInput) {
                        var newValue = !ngModel.$modelValue;
                        ngModel.$setViewValue(newValue);

                        element.find('input').prop('checked', newValue);

                        // with ng1.2 the model change on key event is not propagated
                        // to parent components, so we are urged to call a global digest
                        $rootScope.$digest();
                    }
                }
            });

        },
        templateUrl: 'templates/capCheckbox.html',
        transclude: true
    }
}
'use strict';

/* Directives */

angular.module('substoreApp.directives')

    /**
     * Validator directive for an input; checks if the value is a valid email.
     */
    .directive('capEmail', ['emailValidationService', function(emailValidationService) {
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {
                ctrl.$validators.capEmail = function(modelValue, viewValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return true; // consider empty models to be valid
                    }
                    return emailValidationService.isValid(viewValue);
                };
            }
        };
    }]);
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to show a button expanding and collapsing content details
 */
    .directive('capExpandCollapseButton', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            transclude: true,
            scope: {
                owner: "=?",
                subowner: "=?"
            },
            link: function link(scope, element, attrs, ngModel) {
                scope.toggle = function() {
                    ngModel.$setViewValue(!ngModel.$viewValue);
                };

                scope.isExpanded = function() {
                    return ngModel.$viewValue;
                };

                scope.capId = 'toggle' + (scope.owner && '_' + scope.owner) + (scope.subowner && '_' + scope.subowner);

                scope.hintExpand = attrs.hintExpand || 'collapse_tooltip_closed';
                scope.hintCollapse = attrs.hintCollapse || 'collapse_tooltip_opened';
            },
            templateUrl: "templates/expandcollapsebutton.html"
        }
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to show action button on MyProducts
 */
    .directive('capMyproductsAction', function () {
        return {
            restrict: 'A',
            scope: {
                product: "=",
                productOption: "=",
                action: "=",
                actions: "="
            },
            link: function (scope, element, attrs) {
                scope.style = (attrs.spaceAbove ? { 'margin-top' : '10px' } : { });

                scope.$watch("actions.isInProgress(action, productOption.uniqueSubscriptionId)", function(inProgress) {
                    if (inProgress)
                        scope.productOption.isDetailsCollapsed = true;
                });
            },
            templateUrl: "templates/myproductsaction.html"
        }
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to confirm action button on MyProducts
 */
    .directive('capMyproductsActionConfirmation', function () {
        return {
            restrict: 'A',
            scope: {
                product: "=",
                productOption: "=",
                action: "=",
                actions: "="
            },
            templateUrl: "templates/myproductsactionconfirmation.html"
        }
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

    /**
     * Renders the 'print order form' (PDF) part.
     */
    .directive('capOrderFormGeneration', ["uiservice", "sessionData", "throwServiceResponseFault", function (uiservice, sessionData, throwServiceResponseFault) {
        return {
            restrict: 'A',
            scope: {
                theData: '=',
                oformFeatureEnabled: '=',
                allowOrderFormGeneration: '=',
                allowReservationEmail: '=',
                allowFinalization: '=',
                isOnlyReservationAllowed: '=',
                confirmation: '='
            },
            controller: ["$scope", function($scope) {
                $scope.printPdf = function printPdf() {
                    uiservice.orderFormGeneration({
                            sessionId: sessionData.sessionId,
                            subscriptionTemplateId: $scope.theData.product.subscriptionTemplateId,
                            onlyReservationAllowed: $scope.isOnlyReservationAllowed,
                            customerEmail: $scope.confirmation.customerEmail
                        },
                        function success(response) {
                            var downloadPath = "/substore/uiservice/orderFormDownload"
                                +"?sessionId="+sessionData.sessionId
                                +"&fileId="+response.data.fileId
                                +"&csrfProtectionToken="+sessionData.csrfProtectionToken;
                            window.open(downloadPath, '_self', '');
                        },
                        throwServiceResponseFault
                    );
                };
            }],
            templateUrl: "templates/orderFormGeneration.html"
        };
    }]);
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product order description
 */
    .directive('capOrderProductDescription', function () {
        return {
            restrict: 'A',
            scope: {
                productName: "=",
                productLogoResourcePath: "=",
                productLogoResourceAlt: "=",
                productDescription: "=",
                providerName: "=",
                hideProvider: "="
            },
            templateUrl: "templates/orderproductdescription.html"
        }
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product order price
 */
    .directive('capOrderProductPrice', function () {
        return {
            restrict: 'A',
            scope: {
                price: "=",
                exemptedFromTax: "=",
                minimumCommitmentPeriodText: "=",
                minimumCommitmentPeriodOverrideText: "=",
                regularPriceOverrideText: "=",
                promotionPriceOverrideText: "=",
                promotionTypeOptin: "=",
                afterOptinInfoText: "=",
                beforeOptinInfoText: "=",
                optinSelected: "=",
                change: "=",
                a: "="
            },
            templateUrl: "templates/orderproductprice.html"
        }
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product order terms
 */
    .directive('capOrderProductTerms', function () {
        return {
            restrict: 'A',
            transclude: true,
            scope: {
                subscriptionBookIsRunning: "=",
                subscriptionBookWorkflowWasInvoked: "=",
                invertColoring: "=",
                texts: "=",
                textLists: "=",
                hyperlinks: "=",
                actions: "=",
                confirmation: "=",
                obligationToPay: "=",
                subscriptionBookedByExtern: "=",
                canNotSucceed: "=",
                bookingAllowed: "=",
                formValid: "=",
                modeOptin: "=?"
            },
            controller: ["$scope", function($scope) {
                if ( $scope.invertColoring === true ) {
                    $scope.alternateBgColor2 = 'cap_order_section_odd';
                    $scope.alternateBgColor1 = 'cap_order_section_even';
                } else {
                    $scope.alternateBgColor1 = 'cap_order_section_odd';
                    $scope.alternateBgColor2 = 'cap_order_section_even';
                }
            }],
            templateUrl: "templates/orderproductterms.html"
        }
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product change description (optional including price)
 */
    .directive('capProductChangeDescription', function () {
        return {
            restrict: 'A',
            scope: {
                productName: "=",
                productLogoResourcePath: "=",
                productLogoResourceAlt: "=",
                productDescription: "="
            },
            templateUrl: "templates/productchangedescription.html"
        }
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product change price
 */
    .directive('capProductChangePrice', function () {
        return {
            restrict: 'A',
            scope: {
                price: "=",
                regularPriceOverrideText: "="
            },
            templateUrl: "templates/productchangeprice.html"
        }
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print product details group (in a non-partner-specific, simple
 * way)
 */
    .directive('capProductDetailsGroup', function () {
        return {
            restrict: 'A',
            scope: {
                selection: "=",
                label: "="
            },
            templateUrl: "templates/productdetailsgroup.html"
        }
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print progress bar
 */
    .directive('capProgressBar', function () {
        var Step = function (id, text, total, current) {
            this.id = id;
            this.text = text;

            this.left = function () {
                return (id == 1);
            };
            this.center = function () {
                return (id > 1 && id < total);
            };
            this.right = function () {
                return (id == total);
            };
            this.highlight = function () {
                return (id <= current);
            };
            this.last = function () {
                return (id == current);
            }
        };

        return {
            restrict: 'A',
            controller: ['$scope', 'progressBar', function ($scope, progressBar) {
                $scope.progressBar = progressBar;
                $scope.steps = undefined;
            }],
            link: function ($scope, element, attr) {
                $scope.$watch('progressBar.config', function() {
                    if ($scope.progressBar && $scope.progressBar.config && $scope.progressBar.config.progressBarEnabled === false)
                        element.hide();
                    else {
                        var labels = $scope.progressBar.getSteps();
                        var current = $scope.progressBar.getStep();

                        if (labels && current) {
                            $scope.steps = [];
                            for (var i = 0; i < labels.length; i++)
                                $scope.steps.push(new Step(i + 1, labels[i], labels.length, current));
                        }
                    }
                });
            },
            templateUrl: "templates/progressbar.html"
        };
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to specify a fallback image on an img if the src cannot be loaded.
 * Usage:
 * <img ng-src="missing-image.jpg" fallback-src="fallback-image.jpg">
 */
    .directive('fallbackSrc', function () {
        return {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                element.bind('error', function () {
                    angular.element(this).attr("src", attrs.fallbackSrc);
                });
            }
        }
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to focus input field when flag changes to true
 */
    .directive('focusMe', ["$timeout", "$parse", function ($timeout, $parse) {
        function focus(element) {
            if (element.attr("tabindex"))
                element[0].focus();
            else {
                // delegate to first child having tab stop
                element = element.find("[tabindex]");
                if (element[0])
                    element[0].focus();
            }
        }

        return {
            link: function (scope, element, attrs) {
                var model = $parse(attrs.focusMe);
                scope.$watch(model, function (value) {
                    if (value === true) {
                        $timeout(function () {
                            focus(element);
                        });
                    }
                });
                element.bind('blur', function () {
                    scope.$apply(model.assign(scope, false));
                });
            }
        };
    }]);
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to add a "loading..." layer div on top of some existing content.
 * The attribute's value must be a boolean expression. When the expression
 * evaluates to true, then the "loading..." layer will be added around the
 * content, otherwise it will be removed again.
 *
 * Usage:
 *
 * <div loading-container="boolean expression to watch">
 *     <!-- content to enable/disable -->
 * </div>
 *
 * For example when used with ngTable, and you have the tableParams in your
 * current controller scope, you could use:
 *
 * <div loading-container="tableParams.settings().$loading">
 *     <table ng-table="...">
 * </div>
 */
    .directive('loadingContainer', function () {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var loadingLayer = angular.element('<div class="loading"></div>');
                element.append(loadingLayer);
                element.addClass('loading-container');
                scope.$watch(attrs.loadingContainer, function (value) {
                    loadingLayer.toggleClass('ng-hide', !value);
                });
            }
        };
    });
'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive which adds bootstrap class 'pull-right' if not IE8
 */
    .directive('pullRightUnlessIe8', function () {

        function isMie8() {
            if (navigator.appName != 'Microsoft Internet Explorer')
                return false;

            var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(navigator.userAgent) != null)
                return (parseFloat(RegExp.$1) < 9);

            return true;
        }

        return {
            restrict: 'C',
            link: function (scope, element, attrs) {

                if (!isMie8())
                    angular.element(element).addClass('pull-right');
            }
        }
    });
'use strict';

/* Controllers */

angular.module('substoreApp.controllers', []);

'use strict';

angular.module('substoreApp.controllers')
    .controller('catalogueController', CatalogueController);

function CatalogueController($scope, dialogData, sessionData, productDataCollector, productDataFinalizer, htmlTruster, webtrekk) {

    $scope.isCatalogueActive = true;

    $scope.breadcrumb.init('navigation_catalogue');

    $scope.data = {
        mainMessage: null,
        filteredProductList: [],
        filteredProductList2d: []
    };

    sessionData.deleteCurrentSubscription();

    var make2d = function (a, itemsPerPage) {
        if (!a) return a;
        var a2d = [], e;
        for (var i = 0, j = 0; i < a.length; i++, j++) {
            if (j % 2 === 0) a2d.push(e = []);

            e.push(a[i]);
            if(itemsPerPage % 2 === 1 && i % itemsPerPage === itemsPerPage - 1) {
                e.push(null);
                j++;
            }
        }
        return a2d;
    };

    function initDialogData() {
        $scope.data = dialogData;

        var productsCount = dialogData.productList.length;
        for (var p = 0; p < productsCount; p++) {
            productDataCollector.collect(dialogData.productList[p]);
            productDataFinalizer.checkAvailability(dialogData.productList[p]);
        }

        $scope.partnerFilter.setAvailableFilters($scope.data.availableFilters);
        $scope.productFilter.setAvailableFilters($scope.data.availableFilters);

        $scope.data.filteredProductList = dialogData.productList;
        htmlTruster.trust($scope.data.filteredProductList);

        if ($scope.data.filteredProductList.length > 0) {
            $scope.data.filteredProductList[0].isOpen = true;
        } else {
            $scope.data.mainMessage = "catalog_msg_empty";
        }
        if ($scope.data.viewFilterList && $scope.data.viewFilterList.length > 0) {
            $scope.pagination.itemsPerPage = $scope.data.viewFilterList[0];
        }

        $scope.data.filteredProductList2d = make2d($scope.data.filteredProductList, $scope.pagination.itemsPerPage);

        $scope.updateTeaser();
        $scope.applyFilters();
    }

    // configure filters

    var Filter = function Filter(filterType) {
        this.filterType = filterType;
        this.criterion = "";
        this.displayName = "";
        this.availableFilters = [];
    };

    Filter.prototype.setFilter = function (f) {
        if (f) {
            this.criterion = f.id;
            this.displayName = f.displayName;
        } else {
            this.criterion = "";
            this.displayName = "";
        }
    };

    Filter.prototype.setAvailableFilters = function (availableFilters) {
        var filters = [];
        if (availableFilters) {
            for (var i = 0; i < availableFilters.length; i++) {
                var f = availableFilters[i];
                if (f.type == this.filterType) {
                    filters.push(f);
                    if (f.initial) {
                        this.setFilter(f);
                    }
                }
            }
        }
        this.availableFilters = filters;
    };

    Filter.prototype.applyCriterion = function (list) {
        if (!this.criterion)
            return list;

        var filteredList = [];
        for (var i = 0; i < list.length; i++) {
            var product = list[i];
            if (product.belongsToFilters.indexOf(this.criterion) >= 0)
                filteredList.push(product);
        }

        return filteredList;
    };

    $scope.partnerFilter = new Filter("partner");
    $scope.productFilter = new Filter("product");

    $scope.applyFilters = function () {
        var list = $scope.partnerFilter.applyCriterion(
            $scope.productFilter.applyCriterion(
                $scope.data.productList));

        $scope.data.filteredProductList = list;
        $scope.data.filteredProductList2d = make2d(list, $scope.pagination.itemsPerPage);

        if ($scope.data.filteredProductList.length > 0) {
            $scope.data.filteredProductList[0].isOpen = true;
            $scope.data.mainMessage = null;
        } else
            $scope.data.mainMessage = "catalog_msg_empty";
    };

    $scope.resetFilters = function () {
        $scope.partnerFilter.setFilter(null);
        $scope.productFilter.setFilter(null);
        $scope.data.filteredProductList = $scope.data.productList;
        if ($scope.data.viewFilterList && $scope.data.viewFilterList.length > 0) {
            $scope.pagination.itemsPerPage = $scope.data.viewFilterList[0];
        }
        $scope.data.filteredProductList2d = make2d($scope.data.productList, $scope.pagination.itemsPerPage);
        $scope.data.mainMessage = null;
    };

    $scope.isFilterExpanded = true;

    // configure pagination

    $scope.pagination = {
        itemsPerPage: 4,
        currentPage: 1,
        forward: function () {
            this.currentPage = (this.isLastPage() ? this.currentPage : this.currentPage + 1);
        },
        backward: function () {
            this.currentPage = (this.currentPage > 1 ? this.currentPage - 1 : 1);
        },
        firstItem: function () {
            return (this.currentPage - 1) * this.itemsPerPage;
        },
        isFirstPage: function () {
            return (this.currentPage == 1);
        },
        isLastPage: function () {
            return ($scope.pagination.currentPage * $scope.pagination.itemsPerPage >= $scope.data.filteredProductList.length);
        },
        isMultiPage: function () {
            return ($scope.pagination.itemsPerPage < $scope.data.filteredProductList.length);
        },
        firstItemHalf: function() {
            if (this.itemsPerPage % 2 === 1) { // in case of uneven items per page
                return Math.ceil((this.firstItem() + (this.currentPage - 1))/2);
            }
            return this.firstItem()/2;
        },
        itemsPerPageHalf: function() {
            return Math.ceil(this.itemsPerPage/2);
        },
        totalCount: function totalCount(){
            return $scope.data.filteredProductList.length;
        },
        from: function from() {
            return ($scope.pagination.currentPage-1)*$scope.pagination.itemsPerPage+1;
        },
        to: function to() {
            var len = this.totalCount();
            return $scope.pagination.isLastPage() ? len : $scope.pagination.currentPage*$scope.pagination.itemsPerPage;
        }
    };

    // configure footnotes

    $scope.footnotes = [];

    var updateFootnotes = function () {
        $scope.footnotes = [];

        for (var i = $scope.pagination.firstItem(); i < $scope.data.filteredProductList.length && i < $scope.pagination.firstItem() + $scope.pagination.itemsPerPage; i++) {
            var p = $scope.data.filteredProductList[i];
            for (var j = 0; j < p.productDescription.footnotes.length; j++)
                $scope.footnotes.push(p.productDescription.footnotes[j]);
        }
    };

    $scope.$watch('data.filteredProductList', updateFootnotes);
    $scope.$watch('pagination.itemsPerPage', updateFootnotes);
    $scope.$watch('pagination.currentPage', updateFootnotes);

    initDialogData();

    webtrekk.track('catalogue', {});
}
'use strict';

angular.module('substoreApp.controllers')
    .controller('errorController', ['$scope', '$routeParams', 'sessionData', 'uiservice', 'webtrekk',
        function ($scope, $routeParams, sessionData, uiservice, webtrekk) {

            $scope.data = {};

            $scope.breadcrumb.init("error");

            $scope.$on('$routeChangeStart', function (scope, next, current) {
                if (next.$$route.originalPath.indexOf("/error") < 0)
                    sessionData.fault = undefined;
                sessionData.deleteCurrentSubscription();
            });

            $scope.messageText = '';
            $scope.fault = sessionData.fault;

            if (!$scope.fault)
                $scope.fault = { code: 'UNEXPECTED_ERROR' };

            if ($routeParams.code || !$scope.fault.code)
                $scope.fault.code = $routeParams.code;

            if ($scope.fault.code) {
                // Do we already have a message text for the code given in routeParams?
                if ($scope.fault.code == $routeParams.code && $scope.fault.message != undefined && $scope.fault.message != null && ($scope.fault.code != 'JAVASCRIPT_EXCEPTION' || sessionData.dialogStaticData.dev)) {
                    $scope.messageText = $scope.fault.message;
                } else {
                    // No, fetch it from server
                    uiservice.faultMessage({
                            sessionId: sessionData.sessionId,
                            errorCode: $scope.fault.code,
                            lang: sessionData.dialogStaticData.language,
                            wpId: sessionData.dialogStaticData.wholesalePartnerId
                        },
                        function success(responseData) {
                            // server returned a head/fault data structure via HTTP 200
                            $scope.fault = sessionData.fault = responseData.head.fault;
                            $scope.messageText = responseData.head.fault.message || '';
                            sessionData.storeSessionData();
                        },
                        function error(errorResponse) {
                            // could not fetch message texts from server
                            // set a dummy fault with english internal message text
                            $scope.fault = sessionData.fault = {
                                code: $scope.fault.code,
                                message: 'Internal error (' + $scope.fault.code + '; HTTP ' + errorResponse.status + ' ' + errorResponse.statusText + ')'
                            };
                            $scope.messageText = sessionData.fault.message;
                            sessionData.storeSessionData();
                        });
                }
                $scope.updateTeaser();
            } else {
                $scope.messageText = '';
            }

            // whenever this errorController is called, save the sessionData
            // immediately so that the current errorCode is persisted (in case
            // the user reloads the page)
            sessionData.storeSessionData();

            if (typeof sessionData.fault.positiveError != 'undefined' && sessionData.fault.positiveError == true) {
                webtrekk.track('positive_backend_error', {});
            } else if (typeof sessionData.sessionId == 'undefined' || !sessionData.sessionId) {
                if (typeof sessionData.fault.code != 'undefined' && sessionData.fault.code == 'EXPIRED_SESSION') {
                    // the session expired. Do not track this.
                } else {
                    webtrekk.track('internal_error', {});
                }
            } else {
                webtrekk.track('backend_error', {});
            }

        }]);

'use strict';

angular.module('substoreApp.controllers').controller('languageController', ['$scope', 'sessionData', 'uiservice', '$filter', '$window',
    function ($scope, sessionData, uiservice, $filter, $window) {

        $scope.languageChanged = function (arg) {

            // get dialog data (if session data is ready)
            sessionData.promise.then(function () {

                sessionData.dialogStaticData.language = arg.toLowerCase();
                sessionData.storeSessionData();

                // inform server about the new language for this user
                // note that we completely ignore any errors here (e.g. session expired),
                // so that this language switch even works in error dialogs
                uiservice.setLanguage({ sessionId: sessionData.sessionId, lang: arg},
                    function success(response) {
                        $window.location.reload();
                    },
                    $scope.throwServiceResponseFault
                );
            });

            return false;
        };

        sessionData.promise.then(function () {
            $scope.options = [];
            var index = 0;
            var pos = 0;
            angular.forEach(sessionData.dialogStaticData.availableLanguages, function (lang) {
                var langCode = lang.toLowerCase();
                if (sessionData.dialogStaticData.language.toLowerCase() == langCode) {
                    index = pos;
                }
                pos++;
                $scope.options.push({
                    value: langCode.toUpperCase(),
                    iso: langCode.toLowerCase(),
                    label: 'language_' + langCode.toUpperCase()
                });
            });

            if (pos < 2) {
                $('.language_selection').hide();
            }
        });

    }]);

'use strict';

angular.module('substoreApp.controllers')
    .controller('logoutController', ['$rootScope', '$scope', '$window', '$compile', '$routeParams', 'uiservice', 'sessionData', 'webtrekk',
        function ($rootScope, $scope, $window, $compile, $routeParams, uiservice, sessionData, webtrekk) {

            $scope.breadcrumb.init("logout");

            if (sessionData && sessionData.sessionId)
                sessionData.promise.then(function () {
                    if (!(sessionData.fault && sessionData.fault.code === "EXPIRED_SESSION"))
                        uiservice.deleteSession({sessionId: sessionData.sessionId, redirectTo: $routeParams.redirectTo},
                            function success(response) {
                                if (response.data.logoutURL) {
                                    // call logout URL in an iframe (we should wait for finish but we can't)
                                    angular.element(document.querySelector('#logout_iframe_container')).append($compile('<iframe src="' + response.data.logoutURL + '" width="1" height="1" />')({}));
                                }

                                if (response.data.partnerLogoutURL) {
                                    // call partner's logout URL in an iframe (we should wait for finish but we can't)
                                    angular.element(document.querySelector('#partner_logout_iframe_container')).append($compile('<iframe src="' + response.data.partnerLogoutURL + '" width="1" height="1" />')({}));
                                }

                                webtrekk.track('logout', {}).promise.then(function() {
                                    sessionData.deleteSessionData();
                                    if (response.data.logoutRedirectURL) {
                                        $window.location.href = response.data.logoutRedirectURL;
                                    }
                                });
                            },
                            $scope.throwServiceResponseFault
                        );
                });

       }
    ]);

'use strict';

angular.module('substoreApp.controllers').controller('masterController', ['$rootScope', '$scope', '$location', '$window', '$anchorScroll', '$translate', 'sessionData', 'partnerFeatureRegistry', 'throwServiceResponseFault', 'progressBar',
    function ($rootScope, $scope, $location, $window, $anchorScroll, $translate, sessionData, partnerFeatureRegistry, throwServiceResponseFault, progressBar) {
        $scope.sessionData = sessionData;

        /*
         * convencience functions for partner feature support
         */
        $scope.lookupFeature = partnerFeatureRegistry.lookupTemplate;
        $scope.applyFeature = partnerFeatureRegistry.applyWithScope;

        /**
         * Generic error handling methods
         */
        $scope.throwServiceResponseFault = throwServiceResponseFault;

        /**
         * breadcrumb - configure data structure and methods to be reused by every specific controller
         */
        $scope.breadcrumb = {
            crumbs: undefined,
            init: function (name, url) {
                this.crumbs = [
                    { name: name, url: url }
                ];
                this.updateTitle(name);
            },
            add: function (name, url) {
                this.crumbs.push({ name: ">" });
                this.crumbs.push({ name: name, url: url });
                this.updateTitle(name);
            },
            updateTitle: function (name) {
                // 3.2.3 Page Title
                // Note: we cannot use angularjs binding for <title> element, because it doesn't work with IE8
                // Note: title is first set in app.js
                $translate('title').then(function (title) {
                    $translate(name).then(function (title2) {
                        $window.document.title = title + ' - ' + title2;
                    });
                });
            }
        };

        /**
         * progress bar (required in most controllers)
         */

        $scope.progressBar = progressBar;

        /**
         * teaser
         */
        $scope.resetTeaser = function () {
            $scope.teaser = {
                title: "",
                subtitle: "",
                imageResourcePath: null,
                imageResourcePathFallback: null
            };
        };

        $scope.updateTeaser = function (title, subTitle, imageResourcePath) {
            if (title) {
                $scope.teaser.title = title;
                $scope.teaser.subtitle = subTitle;
            } else {
                // CAP-533
                $translate('teaser_default_title').then(function (translation) {
                    $scope.teaser.title = translation;
                });
                $translate('teaser_default_subtitle').then(function (translation) {
                    $scope.teaser.subtitle = translation;
                });
            }
            if (imageResourcePath) {
                $scope.teaser.imageResourcePath = "../../resources/" + imageResourcePath;
            } else {
                var natCoName = sessionData.dialogStaticData.natCoName;
                var wpid = sessionData.dialogStaticData.wholesalePartnerId;
                var randomNumber = Math.floor(Math.random() * 10 % 4 + 1).toString(); // from 1 to 4
                $scope.teaser.imageResourcePathFallback = "img/teaser" + randomNumber + ".jpg";
                if (natCoName && wpid) {
                    // the resource must exist! (but if it doesn't then HTML uses the fallback, see indexheader.html)
                    $scope.teaser.imageResourcePath = "natco/" + natCoName + "/teaser" + randomNumber + "-" + wpid + ".jpg";
                } else {
                    // natCoName and wpid are only undefined in case of errors. In this case we show generic default pictures
                    $scope.teaser.imageResourcePath = $scope.teaser.imageResourcePathFallback;
                }
            }
        };

        $scope.resetTeaser();

        $rootScope.$on("$locationChangeStart",
            function (event, next, current) {
                $scope.resetTeaser();
            });

        /**
         * Go to a certain location.
         * Useful in buttons or links, e.g.:
         * &lt;a ng-href="{{go('/subdialog')}}&gt;link&lt;/a&gt;
         *
         * @param path (string) relative or absolute path
         * @param [replace] (boolean) if true, all changes to $location
         * during current "$digest" will be replacing current history
         * record, instead of adding new one
         */
        $scope.go = function (path, replace) {
            $location.path(path);
            if (replace) {
                $location.replace();
            }

            return $location;
        };

        /**
         * Go to either myproducts or catalogue - if allowed
         */
        $scope.cancel = function (/*boolean*/ toMyProducts) {
            var targetLocation = null;

            if (toMyProducts && sessionData.dialogStaticData.showMyProducts)
                targetLocation = "/myproducts";
            else if (!toMyProducts && sessionData.dialogStaticData.showCatalogue)
                targetLocation = "/catalogue";
            else
                throw { code: "CANCEL_TARGET_DIALOGUE_NOT_ALLOWED" };

            $location.path(targetLocation);
        };

        /**
         * Let the browser go back.
         * Useful in buttons or links: <a ng-href="{{back()}}>go back</a>
         */
        $scope.back = function () {
            $window.history.back();
        };

        /**
         * Go to top of page
         */
        $scope.goTop = function () {
            $anchorScroll();
        };

        /**
         * configure global idiomatic routing rules
         */
        $rootScope.$on("$locationChangeStart",
            function (event, next, current) {
                var nextToken = next.match("#/[^/#]*");
                var currentToken = current.match("#/[^/#]*");

                function contains(a, o) {
                    for (var i = 0; i < a.length; i++) {
                        if (a[i] === o) {
                            return true;
                        }
                    }
                    return false;
                }

                if (currentToken) {
                    switch (currentToken[0]) {
                        case "#/orderconfirmation" :
                        case "#/productchangeconfirmation" :
                        case "#/orderadministrationconfirmation" :
                            if (current !== next)
                                sessionData.deleteCurrentSubscription();
                            if (nextToken[0] && !contains(["#/", "#/myproducts", "#/catalogue", "#/logout", "#/error", currentToken[0]], nextToken[0]))
                                event.preventDefault();
                            break;
                        case "#/logout" :
                            if (nextToken[0] && !contains(["#/logout", "#/error", currentToken[0]], nextToken[0]))
                                event.preventDefault();
                            break;
                    }
                }

                if (nextToken) {
                    // temporary 18.2.1 solution: if logout button must not be shown then we
                    // know that catalogue and myproducts are not provided by substore itself
                    var target = nextToken[0];
                    if (sessionData.dialogStaticData && sessionData.dialogStaticData.showLogout === false && (target == "#/catalogue" || target == "#/myproducts")) {
                        $location.path( "/logout" + target.substring(1) );
                    }

                    // each part might deliver its own footnotes (or not). Unfortunately those footnotes
                    // are part of footer rather than variable part of view so we have to reset here
                    $scope.footnotes = "";
                }
            }
        );

        /* provide custom resources */

        $scope.customResource = function(key) {
            return sessionData && sessionData.dialogStaticData && sessionData.dialogStaticData.customResources && sessionData.dialogStaticData.customResources[key];
        };
    }
]);
'use strict';

angular.module('substoreApp.controllers')
    .controller('myproductsController', MyproductsController);

function MyproductsController($scope, $routeParams, dialogData, sessionData, uiservice, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts");

    $scope.footnotes = [];

    sessionData.deleteCurrentSubscription();

    var allFootnotes = [];

    var limitedFootnotes = null;
    var limitedToSubscriptionTemplateId = $routeParams.subscriptionTemplateId || null;

    function configureGrouping(productList) {
        for (var p = 0; p < productList.length; p++) {
            var product = productList[p];

            product.isSingleOption = (product.productOptions.length === 1);
            product.productOptions[0].isFirstOption = true;
            product.productOptions[(product.productOptions.length - 1)].isLastOption = true;
        }
    }

    function getDialogData() {
        return uiservice.myProductsOverviewDialogData({sessionId: sessionData.sessionId},
            function success(response) {
                initDialogData(response.data);
            },
            $scope.throwServiceResponseFault
        ).$promise;
    }

    function initDialogData(data) {
        data = data || dialogData;

        $scope.footnotes = [];

        data.visibleProductList = (limitedToSubscriptionTemplateId ? [] : data.productList);

        var limitedToProduct = null;

        var productsCount = data.productList.length;
        for (var p = 0; p < productsCount; p++) {

            var product = productDataCollector.collect(data.productList[p]);

            for (var i = 0; i < product.productDescription.footnotes.length; i++)
                allFootnotes.push(product.productDescription.footnotes[i]);

            if (limitedToSubscriptionTemplateId && limitedToSubscriptionTemplateId === product.subscriptionTemplateId) {
                data.visibleProductList.push(product);

                for (var o = 0; o < product.productOptions.length; o++)
                    product.productOptions[o].isDetailsExpanded = true;

                limitedFootnotes = [];
                for (var i = 0; i < product.productDescription.footnotes.length; i++)
                    limitedFootnotes.push(product.productDescription.footnotes[i]);

                limitedToProduct = product;
            }

            // because template properties do not match to implemented action keys, we give each product a translation map
            product.actionLabels = {
                "myproducts_btn_cancel": product.texts.orderCancellationButtonLabel,
                "myproducts_btn_termination": product.texts.orderTerminationButtonLabel,
                "myproducts_btn_reservationTermination": product.texts.orderReservationDeletionButtonLabel,
                "myproducts_btn_reactivation": product.texts.orderReactivationButtonLabel,
                "myproducts_btn_productChange": product.texts.productChangeButtonLabel,
                "myproducts_btn_finalize": product.texts.orderFinalisationButtonLabel,
                "myproducts_btn_administration": product.texts.orderAdministrationButtonLabel,
                "myproducts_btn_resume": product.texts.orderReservationFinalisationButtonLabel,
                "myproducts_btn_optin": product.texts.orderOptinButtonLabel,
                "myproducts_prompt_cancel": product.texts.orderCancellationQuestion,
                "myproducts_prompt_cancel_date": product.texts.orderCancellationDateQuestion,
                "myproducts_prompt_termination": product.texts.orderTerminationQuestion,
                "myproducts_prompt_reservationTermination": product.texts.orderReservationDeletionQuestion,
                "myproducts_prompt_reactivation": product.texts.orderReactivationQuestion,
                "myproducts_succeeded_cancel": product.texts.orderCancellationSucceeded,
                "myproducts_succeeded_termination": product.texts.orderTerminationSucceeded,
                "myproducts_succeeded_reservationTermination": product.texts.orderReservationDeletionSucceeded,
                "myproducts_succeeded_reactivation": product.texts.orderReactivationSucceeded
            };
        }

        $scope.footnotes = limitedFootnotes || allFootnotes;

        configureGrouping(data.productList);

        $scope.data = data;

        htmlTruster.trust($scope.data.visibleProductList);

        if (limitedToProduct)
            $scope.updateTeaser(
                limitedToProduct.texts.headerTitleMyProducts,
                limitedToProduct.texts.headerSubTitleMyProducts,
                limitedToProduct.images.headerImageMyProductsResourcePath);
        else
            $scope.updateTeaser();
    }

    // some helper functions

    function findProduct(subscriptionTemplateId, gracefully) {
        var productList = $scope.data.productList;
        for (var p = 0; p < productList.length; p++)
            if (productList[p].subscriptionTemplateId === subscriptionTemplateId)
                return productList[p];

        if (gracefully)
            return null;

        throw "cannot find product " + subscriptionTemplateId;
    }

    function findProductOption(subscriptionTemplateId, uniqueSubscriptionId, gracefully) {
        var product = findProduct(subscriptionTemplateId, gracefully);
        if (product) {
            var optionList = product.productOptions;
            for (var o = 0; o < optionList.length; o++)
                if (optionList[o].uniqueSubscriptionId == uniqueSubscriptionId)
                    return optionList[o];
        }

        if (gracefully)
            return null;

        throw "cannot find product option " + subscriptionTemplateId + "/" + uniqueSubscriptionId;
    }

    function getCollapseStates() {
        var states = {};
        for (var p = 0; p < $scope.data.productList.length; p++) {
            var product = $scope.data.productList[p];
            for (var o = 0; o < product.productOptions.length; o++) {
                var option = product.productOptions[o];

                states[option.uniqueSubscriptionId] = option.isDetailsExpanded;
            }
        }

        return states;
    }

    function applyCollapseStates(states) {
        for (var p = 0; p < $scope.data.productList.length; p++) {
            var product = $scope.data.productList[p];
            for (var o = 0; o < product.productOptions.length; o++) {
                var option = product.productOptions[o];

                option.isDetailsExpanded = states[option.uniqueSubscriptionId];
            }
        }
    }

    function forceExpand(uniqueSubscriptionId) {
        for (var p = 0; p < $scope.data.productList.length; p++) {
            var product = $scope.data.productList[p];
            for (var o = 0; o < product.productOptions.length; o++) {
                var option = product.productOptions[o];

                if (uniqueSubscriptionId === option.uniqueSubscriptionId) {
                    option.isDetailsExpanded = true;
                    return;
                }
            }
        }
    }

    function hideButtons(productOption) {
        for (var attribute in productOption)
            if (productOption.hasOwnProperty(attribute) && attribute.indexOf("Allowed", attribute.length - 7) !== -1)
                productOption[attribute] = false;
    }

    // configure actions

    $scope.actions = {
        inProgress: { },
        succeeded: { },
        // service actions are those which require a call to the MyProduct action service on server.
        serviceActions: {
            reactivation: "reactivate",
            termination: "terminate",
            reservationTermination: "terminateReservation",
            orderDeletion: "terminateReservation",
            optin: "optin"
        },
        // routes for actions which start a navigation to another location
        routes: {
            "resume": "/orderselection/:subscriptionTemplateId",
            "productChange": "/productchangeselection/:subscriptionTemplateId/:uniqueSubscriptionId",
            "administration": "/orderadministrationselection/:subscriptionTemplateId/:uniqueSubscriptionId",
            "finalize": "/orderselection/:subscriptionTemplateId",
            "optin": function (subscriptionTemplateId, uniqueSubscriptionId) {
                // call MyProducts action "optin" on server to generate a new orderCallId,
                // then go to order summary with the new orderCallId (order summary _requires_ it)
                $scope.actions.invoke("optin", subscriptionTemplateId, uniqueSubscriptionId);
            }
        },
        invoke: function (action, subscriptionTemplateId, uniqueSubscriptionId) {
            action = (this.serviceActions[action] ? this.serviceActions[action] : action);

            var callback = function () {
                uiservice.myProductsAction({
                        sessionId: sessionData.sessionId,
                        uniqueSubscriptionId: uniqueSubscriptionId,
                        action: action
                    },
                    function success(response) {
                        // special case "optin": go to ordersummary afterwards
                        if (action === "optin") {
                            $scope.go("/ordersummary/" + subscriptionTemplateId + "/" + response.data.orderCallId + "/optin");
                            return;
                        }
                        // save option and position targeted by last action
                        var targetedProduct = findProduct(subscriptionTemplateId);
                        var targetedOption = findProductOption(subscriptionTemplateId, uniqueSubscriptionId);
                        var targetedProductPos = $scope.data.productList.indexOf(targetedProduct);

                        var collapseStates = getCollapseStates();

                        getDialogData().then(function () {
                            applyCollapseStates(collapseStates);

                            // enrich loaded options with option targeted by last action, as necessary
                            var actualProduct = findProduct(subscriptionTemplateId, true);
                            if (actualProduct) {
                                var actualOption = findProductOption(subscriptionTemplateId, uniqueSubscriptionId, true);
                                if (!actualOption) {
                                    actualProduct.productOptions.splice(targetedProduct.productOptions.indexOf(targetedOption), 0, targetedOption);
                                    hideButtons(targetedOption);
                                }
                            } else {
                                $scope.data.productList.splice(targetedProductPos, 0, targetedProduct);
                                hideButtons(targetedOption);
                            }

                            configureGrouping($scope.data.productList);

                            // handle new states
                            $scope.actions.succeeded[uniqueSubscriptionId] = $scope.actions.inProgress[uniqueSubscriptionId];
                            $scope.actions.inProgress[uniqueSubscriptionId] = {};
                        });
                    },
                    $scope.throwServiceResponseFault
                );
            };

            /*if ($.inArray(action, ['cancel', 'termination', 'reactivation', 'reservationTermination', 'orderDeletion']) !== -1) {
                webtrekk.track('myproducts_confirmation_' + action.toLowerCase(), {shop_product_sku: subscriptionTemplateId}).promise.then(callback);
            } else {
                callback();
            }*/
            callback();

        },
        go: function (action, subscriptionTemplateId, uniqueSubscriptionId) {
            var route = this.routes[action];
            if (route instanceof Function) {
                route(subscriptionTemplateId, uniqueSubscriptionId);
            } else {
                // replace placeholders in path, if any
                var path = route.replace(/:subscriptionTemplateId/g, subscriptionTemplateId)
                                .replace(/:uniqueSubscriptionId/g, uniqueSubscriptionId);
                $scope.go(path);
            }
        },
        isLocalAction: function (action) {
            return this.routes[action] == undefined;
        },
        isInProgress: function (action, uniqueSubscriptionId) {
            return (this.inProgress[uniqueSubscriptionId] ? this.inProgress[uniqueSubscriptionId][action] : false);
        },
        isSucceeded: function (action, uniqueSubscriptionId) {
            return (this.succeeded[uniqueSubscriptionId] ? this.succeeded[uniqueSubscriptionId][action] : false);
        },
        isSomethingInProgress: function (uniqueSubscriptionId) {
            var flags = this.inProgress[uniqueSubscriptionId];
            if (!flags) {
                return false;
            }
            for (var flag in flags) {
                if (flags[flag]) {
                    return true;
                }
            }
            return false;
        },
        promptArgs: function (action, productOption) {
            if (action === 'cancel')
                return { 'cancellationDate': productOption.cancellationDate }
            else
                return {};
        },
        toggleInProgress: function (action, uniqueSubscriptionId, subscriptionTemplateId) {
            var flags = this.inProgress[uniqueSubscriptionId];
            if (!flags) {
                flags = this.inProgress[uniqueSubscriptionId] = {};
            }

            flags[action] = !flags[action];

            if (flags[action]) {
                //webtrekk.track('myproducts_confirmation_' + action.toLowerCase(), {shop_product_sku: subscriptionTemplateId});

                forceExpand(uniqueSubscriptionId);
            }

            for (var flag in flags)
                if (flag !== action)
                    flags[flag] = false;
        }
    };

    // only for limited view: show all products
    $scope.showAllProducts = function() {
        $scope.go("/myproducts");
    };

    initDialogData();

    webtrekk.track('myproducts_overview', {});
}

'use strict';

angular.module('substoreApp.controllers')
    .controller('orderadministrationconfirmationController', OrderadministrationconfirmationController);

function OrderadministrationconfirmationController($scope, dialogData, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("administration");

    $scope.progressBar.setup({ step: 3, administration: true });

    function initDialogData() {
        var data = $scope.data = dialogData;

        var product = productDataCollector.collect(data.product);

        $scope.updateTeaser(
            product.texts.headerTitleProductChangeConfirmation,
            product.texts.headerSubTitleProductChangeConfirmation,
            product.images.headerImageChangeConfirmationResourcePath);

        htmlTruster.trust($scope.data.product);

        $scope.footnotes = product.productDescription.footnotes;

        webtrekk.track('order_administration_confirmation', {
            page_content_id: product.texts.productName.toString() + "-" + product.subscriptionTemplateId,
            shop_product_sku: product.subscriptionTemplateId
        });
    }

    initDialogData();
}

'use strict';

angular.module('substoreApp.controllers')
    .controller('orderadministrationselectionController', OrderadministrationselectionController);

function OrderadministrationselectionController($scope, $routeParams, dialogData, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("administration");

    $scope.progressBar.setup({ step: 1, administration: true });

    $scope.confirmation = {
        requestedParameterValue: $routeParams.requestedParameterValue
    };

    var subscriptionTemplateId = $routeParams.subscriptionTemplateId;
    var uniqueSubscriptionId = $routeParams.uniqueSubscriptionId;

    function initDialogData() {
        var data = $scope.data = dialogData;

        var product = productDataCollector.collect(data.product);

        $scope.updateTeaser(
            product.texts.headerTitleAdministrationSelection,
            product.texts.headerSubTitleAdministrationSelection,
            product.images.headerImageAdministrationSelection);

        htmlTruster.trust($scope.data.product);

        $scope.footnotes = product.productDescription.footnotes;

        $scope.applyFeature($scope, [ $scope.data.partnerName, 'orderadministrationselection', 'dialog' ]);

        webtrekk.track('order_administration_selection', {
            page_content_id: product.texts.productName.toString() + "-" + product.subscriptionTemplateId,
            shop_product_sku: product.subscriptionTemplateId
        });
    }

    $scope.nextClicked = false;

    $scope.next = function() {
        if ($scope.nextClicked)
            return;
        var valid = $scope.applyFeature($scope, [ $scope.data.partnerName, 'orderadministrationselection', 'validation' ]);
        if (valid) {
            $scope.nextClicked = true;

            $scope.go("/orderadministrationsummary/" + subscriptionTemplateId + "/" + uniqueSubscriptionId + "/" + $scope.confirmation.requestedParameterValue);
        }
    };

    $scope.cancel = function() {
        if ($scope.nextClicked)
            return;
        $scope.nextClicked = true;
        $scope.go("/myproducts");
    };

    initDialogData();
}

'use strict';

angular.module('substoreApp.controllers')
    .controller('orderadministrationsummaryController', OrderadministrationsummaryController);

function OrderadministrationsummaryController($scope, $routeParams, dialogData, uiservice, sessionData, productDataCollector, orderProductTermsConfirmation, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("administration");

    $scope.progressBar.setup({ step: 2, administration: true });

    $scope.confirmation = orderProductTermsConfirmation();

    var subscriptionTemplateId = $routeParams.subscriptionTemplateId;
    var uniqueSubscriptionId = $routeParams.uniqueSubscriptionId;
    var requestedParameterValue = $routeParams.requestedParameterValue;

    function initDialogData() {
        var data = $scope.data = dialogData;

        productDataCollector.collect(data.product);

        $scope.updateTeaser(
            data.product.texts.headerTitleAdministrationSummary,
            data.product.texts.headerSubTitleAdministrationSummary,
            data.product.images.headerImageAdministrationSummary);

        htmlTruster.trust(data.product);

        $scope.footnotes = data.product.productDescription.footnotes;

        $scope.applyFeature($scope, [ data.partnerName, 'orderadministrationsummary', 'dialog' ]);

        webtrekk.track('order_administration_summary', {
            page_content_id: data.product.texts.productName.toString() + "-" + data.product.subscriptionTemplateId,
            shop_product_sku: data.product.subscriptionTemplateId
        });
    }

    // configure routing dialog functions

    $scope.nextClicked = false;

    $scope.next = function () {
        if ($scope.nextClicked)
            return;

        if ($scope.confirmation.failed(
                null,
                null,
                $scope.data.product.textLists.textToBeConfirmedAdministrationSummary,
                $scope.data.product.textLists.textToBeConfirmedChangeSummary,
                null))
            return;

        $scope.nextClicked = true;

        uiservice.orderAdministrationAction({
                sessionId: sessionData.sessionId,
                subscriptionTemplateId: subscriptionTemplateId,
                uniqueSubscriptionId: uniqueSubscriptionId,
                requestedParameterValue: requestedParameterValue
            },
            function success(response) {
                $scope.go("/orderadministrationconfirmation/" + subscriptionTemplateId + "/" + uniqueSubscriptionId);
            },
            $scope.throwServiceResponseFault
        );
    };

    $scope.cancel = function () {
        if ($scope.nextClicked)
            return;
        $scope.nextClicked = true;
        $scope.go("/myproducts");
    };

    $scope.change = function () {
        if ($scope.nextClicked)
            return;
        $scope.nextClicked = true;
        $scope.go('/orderadministrationselection/' + subscriptionTemplateId + '/' + uniqueSubscriptionId + "/" + requestedParameterValue);
    };

    initDialogData();
}
'use strict';

angular.module('substoreApp.controllers')
    .controller('orderconfirmationController', OrderconfirmationController);

function OrderconfirmationController($scope, $routeParams, dialogData, sessionData, productDataCollector, optinProductTransformer, htmlTruster, webtrekk) {

    $scope.mode = { optin: ($routeParams.mode === "optin") ? true : undefined };
    $scope.confirmationInProgress = $routeParams.mode === "inProgress";

    $scope.progressBar.reset();

    $scope.isCatalogueActive = true;

    function initDialogData() {
        var data = $scope.data = dialogData;

        var keyword = $scope.mode.optin ? 'Optin' : $scope.confirmationInProgress  ? 'InProgress' : '';
        var product = optinProductTransformer.transform(productDataCollector.collect(data.product), keyword);

        $scope.breadcrumb.init(
            data.subscriptionBookedByExtern ? "navigation_myproducts" : "navigation_catalogue",
            data.subscriptionBookedByExtern ? "#/myproducts": "#/");
        $scope.breadcrumb.add(product.texts.productName, "#/productdetails/" + (product.productGroup || product.subscriptionTemplateId));
        $scope.breadcrumb.add("order");

        if (data.subscriptionBookedByExtern) {
            $scope.isCatalogueActive = false;
            $scope.isMyProductsActive = true;
        }

        // TODO mvz: Make the next two lines sense?? In the updateTeaser function title and subtitle will be overridden anyway.
        $scope.teaser.title = product.texts.headerTitleConfirmation && product.texts.headerTitleConfirmation.toLocaleUpperCase();
        $scope.teaser.subtitle = product.texts.headerSubTitleConfirmation && product.texts.headerSubTitleConfirmation.toLocaleUpperCase();

        $scope.updateTeaser(
            product.texts.headerTitleConfirmation,
            product.texts.headerSubTitleConfirmation,
            product.images.headerImageConfirmationResourcePath);

        $scope.progressBar.setup({
            step: 3,
            isOnlyReservationAllowed: data.isOnlyReservationAllowed,
            isPurchaseRedirectRequired: data.isPurchaseRedirectRequired,
            thirdPartyAuthentication: data.thirdPartyAuthentication,
            progressBarEnabled: data.progressBarEnabled,
            optin: $scope.mode.optin,
            hideSelection: dialogData.orderSelectionSkipped
        });

        htmlTruster.trust($scope.data.product);

        $scope.footnotes = product.productDescription.footnotes;

        webtrekk.track('order_confirmation', {
            shop_product_name: product.texts.productName,
            shop_product_quantity: "1",
            shop_product_sku: product.subscriptionTemplateId,
            shop_product_status: "conf",
            shop_order_value: sessionData.transient.priceValue,
            shop_order_id: sessionData.transient.uniqueSubscriptionId
        });
        sessionData.transient.priceValue = undefined;
        sessionData.transient.uniqueSubscriptionId = undefined;

    }

    initDialogData();
}
'use strict';

angular.module('substoreApp.controllers')
    .controller('orderselectionController', OrderselectionController);

function OrderselectionController($scope, $window, dialogData, uiservice, sessionData, productDataCollector, htmlTruster, webtrekk, $log) {

    $scope.isCatalogueActive = true;

    $scope.progressBar.reset();

    $scope.confirmation = {
        // this might get used by some partner features
        requestedParameterValue: null,
        // fields to be provided for oform directive
        createCustomerOrderForm: false,
        customerSignatureObtained: false,
        customerEmail: ""
    };

    function initDialogData() {
        var data = $scope.data = dialogData;
        var product = productDataCollector.collect(data.product);

        sessionData.transient.orderCallId = data.orderCallId;

        if (data.subscriptionBookedByExtern) {
            $scope.isCatalogueActive = false;
            $scope.isMyProductsActive = true;
        }

        htmlTruster.trust($scope.data.product);

        $scope.data.dataTransferAccepted = true;

        $scope.footnotes = product.productDescription.footnotes;

        $scope.confirmation.customerEmail = data.customerEmail;

        $scope.applyFeature($scope, [ $scope.data.partnerName, 'orderselection', 'dialog' ]);

        if (data.orderSelectionSkipped) {
            $scope.next();
            return;
        }

        $scope.breadcrumb.init(
            data.subscriptionBookedByExtern ? "navigation_myproducts" : "navigation_catalogue",
            data.subscriptionBookedByExtern ? "#/myproducts": "#/");
        $scope.breadcrumb.add(product.texts.productName, "#/productdetails/" + (product.productGroup || product.subscriptionTemplateId));
        $scope.breadcrumb.add("order");

        $scope.updateTeaser(
            product.texts.headerTitleSelection,
            product.texts.headerSubTitleSelection,
            product.images.headerImageSelectionResourcePath);

        $scope.progressBar.setup({
            step: 1,
            isOnlyReservationAllowed: data.isOnlyReservationAllowed,
            isPurchaseRedirectRequired: data.isPurchaseRedirectRequired,
            thirdPartyAuthentication: data.thirdPartyAuthentication,
            progressBarEnabled: data.progressBarEnabled
        });

        if ( data.isOnlyReservationAllowed ) {
            webtrekk.track('order_reservation', {
                shop_product_sku: product.subscriptionTemplateId
            });
        } else {
            webtrekk.track('order_selection', {
                shop_product_name: product.texts.productName,
                shop_product_quantity: "1",
                shop_product_sku: product.subscriptionTemplateId,
                shop_product_status: "add"
            });
        }
    }

    // configure routing dialog functions

    $scope.nextClicked = false;

    $scope.next = function () {
        if ($scope.nextClicked)
            return;
        var valid = $scope.applyFeature($scope, [ $scope.data.partnerName, 'orderselection', 'validation' ]);
        if (valid) {
            $scope.nextClicked = true;

            uiservice.subscriptionBegin({
                    sessionId: sessionData.sessionId,
                    orderCallId: sessionData.transient.orderCallId,
                    subscriptionTemplateId: $scope.data.product.subscriptionTemplateId,
                    dataTransferAccepted: $scope.data.dataTransferAccepted,
                    requestedParameter: $scope.confirmation.requestedParameterValue,
                    createCustomerOrderForm: $scope.confirmation.createCustomerOrderForm,
                    customerSignatureObtained: $scope.confirmation.customerSignatureObtained,
                    customerEmail: $scope.confirmation.customerEmail},
                function success(response) {
                    var shouldProceed = $scope.applyFeature($scope, [ $scope.data.partnerName, 'orderselection', 'next' ]);
                    if (shouldProceed) {
                        if (response.data.reserved) {
                            $scope.go("/reservationconfirmation/" + $scope.data.product.subscriptionTemplateId);
                        } else {
                            if (($scope.data.subscriptionBookedByExtern || response.data.redirectRequired) && response.data.authenticationURL) {

                                /*webtrekk.track('order_registration', {
                                    shop_product_name: $scope.data.product.texts.productName,
                                    shop_product_quantity: "1",
                                    shop_product_sku: $scope.data.product.subscriptionTemplateId
                                }).promise.then(function() {
                                    $window.location.href = response.data.authenticationURL;
                                });*/
                                $window.location.href = response.data.authenticationURL;

                            } else {
                                // either we don't need to authenticate at a 3rd party site, or we already have done it
                                $scope.go("/ordersummary/" + $scope.data.product.subscriptionTemplateId + "/" + sessionData.transient.orderCallId);
                            }
                        }
                    }
                },
                $scope.throwServiceResponseFault
            );
        }
    };

    initDialogData();
}
'use strict';

angular.module('substoreApp.controllers')
    .controller('ordersummaryController', OrdersummaryController);

function OrdersummaryController($scope, $routeParams, $window, dialogData, uiservice, sessionData, productDataCollector, optinProductTransformer, orderProductTermsConfirmation, htmlTruster, webtrekk) {

    $scope.mode = { optin: ($routeParams.mode === "optin") ? true : undefined };

    sessionData.transient.subscriptionTemplateId = $routeParams.subscriptionTemplateId;
    sessionData.transient.orderCallId = $routeParams.orderCallId;

    $scope.isCatalogueActive = true;
    $scope.nextClicked = false;

    $scope.progressBar.reset();

    $scope.confirmation = orderProductTermsConfirmation();

    $scope.actions = {
        next: function () {
            if ($scope.nextClicked)
                return;
            if ($scope.confirmation.failed(
                $scope.data.product.hyperlinks.termsOrderLinkUrl,
                $scope.data.product.hyperlinks.rescissionOrderLinkUrl,
                $scope.data.product.textLists.textToBeConfirmedSummary,
                $scope.data.product.textLists.textToBeConfirmedChangeSummary,
                $scope.data.product.texts.emailTextProductOrder))
                return;
            $scope.nextClicked = true;
            $scope.data.subscriptionBookWorkflowWasInvoked = true;
            uiservice.subscriptionBook({
                    sessionId: sessionData.sessionId,
                    orderCallId: orderCallId,
                    subscriptionTemplateId: $scope.data.product.subscriptionTemplateId,
                    acceptTerms: $scope.confirmation.ok.acceptTerms,
                    acceptRescissionRights: $scope.confirmation.ok.acceptRescissionRights,
                    customerEmail: $scope.confirmation.customerEmail,
                    optin: $scope.mode.optin
                },
                function success(response) {
                    if (sessionData.dialogStaticData.enableWebtrekkIntegration && response.data != null) {
                        // remember price and uniqueSubscriptionId for order confirmation dialog
                        sessionData.transient.priceValue = response.data.priceValue;
                        sessionData.transient.uniqueSubscriptionId = response.data.uniqueSubscriptionId;
                    }

                    var url = "/orderconfirmation/" + $scope.data.product.subscriptionTemplateId;
                    if ($scope.mode.optin)
                        url = url + "/optin";
                    else if (response.data != null && response.data.confirmationInProgress != null && response.data.confirmationInProgress) {
                        url = url + "/inProgress";
                    }
                    $scope.go(url);
                },
                $scope.throwServiceResponseFault
            );
        },
        cancel: function () {
            if ($scope.nextClicked)
                return;
            $scope.nextClicked = true;
            uiservice.subscriptionCancel({sessionId: sessionData.sessionId});
            sessionData.deleteCurrentSubscription();
            $scope.cancel($scope.data.subscriptionBookedByExtern || $scope.mode.optin);
        },
        changeUser: function () {
            if ($scope.nextClicked)
                return;
            $scope.nextClicked = true;
            if ($scope.data.logoutURL) {
                // CAP-1587: don't forget authentication data if we redirect to a 3rd-party URL
                $window.location.href = $scope.data.logoutURL;
            } else {
                uiservice.forgetAuthentication({ sessionId: sessionData.sessionId },
                    function success(response) {
                        if ($scope.data.partnerName === "Spotify" && $scope.data.authenticationURL){
                            $window.location.href = $scope.data.authenticationURL;
                        } else {
                            $scope.go("/orderselection/" + $scope.data.product.subscriptionTemplateId);
                        }

                    },
                    $scope.throwServiceResponseFault
                );
            }
        }
    };

    // we do grab the following items to avoid let global routing rules wipe them out before we can cancel subscription
    var orderCallId = sessionData.transient.orderCallId;

    function initDialogData() {
        var data = $scope.data = dialogData;

        var product = optinProductTransformer.transform(productDataCollector.collect(data.product),'Optin');

        $scope.breadcrumb.init(
            data.subscriptionBookedByExtern ? "navigation_myproducts" : "navigation_catalogue",
            data.subscriptionBookedByExtern ? "#/myproducts": "#/");
        $scope.breadcrumb.add(product.texts.productName, "#/productdetails/" + (product.productGroup || product.subscriptionTemplateId));
        $scope.breadcrumb.add("order");

        if (data.subscriptionBookedByExtern) {
            $scope.isCatalogueActive = false;
            $scope.isMyProductsActive = true;
        }

        $scope.updateTeaser(
            product.texts.headerTitleSummary,
            product.texts.headerSubTitleSummary,
            product.images.headerImageSummaryResourcePath);

        $scope.progressBar.setup({
            step: 2,
            isOnlyReservationAllowed: data.isOnlyReservationAllowed,
            isPurchaseRedirectRequired: data.isPurchaseRedirectRequired,
            thirdPartyAuthentication: data.thirdPartyAuthentication,
            progressBarEnabled: data.progressBarEnabled,
            optin: $scope.mode.optin,
            hideSelection: dialogData.orderSelectionSkipped
        });

        $scope.data = data;

        htmlTruster.trust($scope.data.product);

        $scope.footnotes = product.productDescription.footnotes;

        $scope.confirmation.customerEmail = $scope.confirmation.customerVerificationEmail = (product.texts.emailTextProductOrder ? data.customerEmail : null);
        $scope.confirmation.emailVerification = dialogData.emailVerification;

        webtrekk.track('order_summary', {
            shop_product_name: product.texts.productName,
            shop_product_quantity: "1",
            shop_product_sku: product.subscriptionTemplateId
        });
    }

    initDialogData();
}

'use strict';

angular.module('substoreApp.controllers')
    .controller('processingController', ['$scope', 'sessionData', 'webtrekk',
        function ($scope, sessionData, webtrekk) {

            $scope.breadcrumb.init("your_order");

            if (sessionData.fault && !sessionData.fault.positiveError) {
                $scope.go("/error");
            } else if (!sessionData.fault) {
                $scope.go("/");
            } else {
                $scope.data = sessionData.fault;
                webtrekk.track('positive_backend_error', {});
                $scope.$on('$routeChangeStart', function (scope, next, current) {
                    if (next.$$route.originalPath.indexOf("/processing") < 0)
                        sessionData.fault = undefined;
                    sessionData.deleteCurrentSubscription();
                });
            }
        }]);

'use strict';

angular.module('substoreApp.controllers')
    .controller('productchangeconfirmationController', ProductchangeconfirmationController);

function ProductchangeconfirmationController($scope, $routeParams, dialogData, sessionData, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("product_change");

    $scope.progressBar.setup({ step: 3 });

    function initDialogData() {
        var data = $scope.data = dialogData;

        var product = productDataCollector.collect(data.product);

        $scope.updateTeaser(
            product.texts.headerTitleProductChangeConfirmation,
            product.texts.headerSubTitleProductChangeConfirmation,
            product.images.headerImageChangeConfirmationResourcePath);

        htmlTruster.trust(data.product);

        $scope.footnotes = product.productDescription.footnotes;

        webtrekk.track('productchange_confirmation', {
            shop_product_name: product.texts.productName,
            shop_product_quantity: 1,
            shop_product_sku: $routeParams.subscriptionTemplateId,
            shop_product_status: "conf",
            shop_order_value: sessionData.transient.priceValue,
            shop_order_id: $routeParams.uniqueSubscriptionId
        });

        sessionData.transient.priceValue = undefined;
    }

    initDialogData();
}
'use strict';

angular.module('substoreApp.controllers')
    .controller('productchangeselectionController', ProductchangeselectionController);

function ProductchangeselectionController($scope, $routeParams, dialogData, sessionData, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("product_change");

    $scope.progressBar.setup({ step: 1 });

    $scope.selection = {
        subscriptionTemplateId: undefined,
        click: function(id) {
            if (id === this.subscriptionTemplateId)
                this.subscriptionTemplateId = undefined;
            else
                this.subscriptionTemplateId = id;
        },
        clicked: function(id) {
            if (id === undefined)
                return (this.subscriptionTemplateId !== undefined);

            return (id === this.subscriptionTemplateId);
        }
    };

    function initDialogData() {
        var data = $scope.data = dialogData;

        var product = productDataCollector.collect(data.oldProduct);
        for (var i = 0; i < data.newProducts.length; i++)
            productDataCollector.collect(data.newProducts[i]);

        htmlTruster.trust(product);
        htmlTruster.trust(data.newProducts);

        $scope.updateTeaser(
            product.texts.headerTitleProductChangeSelection,
            product.texts.headerSubTitleProductChangeSelection,
            product.images.headerImageChangeSelectionResourcePath);

        $scope.footnotes = product.productDescription.footnotes;

        webtrekk.track('productchange_selection', {
            shop_product_name: product.texts.productName,
            shop_product_sku: $routeParams.subscriptionTemplateId
        });
    }

    // configure routing dialog functions
    $scope.nextClicked = false;

    $scope.next = function () {
        if ($scope.nextClicked)
            return;
        $scope.nextClicked = true;

        sessionData.transient.subscriptionTemplateId = $scope.selection.subscriptionTemplateId;

        var nextUrl = "/productchangesummary/"+$scope.data.oldProduct.subscriptionTemplateId+"/"+$scope.data.oldProduct.subscription.uniqueSubscriptionId+"/"+$scope.selection.subscriptionTemplateId;

        $scope.go(nextUrl);
    };

    initDialogData();
}
'use strict';

angular.module('substoreApp.controllers')
    .controller('productchangesummaryController', ProductchangesummaryController);

function ProductchangesummaryController($scope, $routeParams, dialogData, uiservice, sessionData, productDataCollector, orderProductTermsConfirmation, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("product_change");

    $scope.progressBar.setup({ step: 2 });

    $scope.confirmation = orderProductTermsConfirmation();

    function initDialogData() {
        var data = $scope.data = dialogData;

        if (sessionData.dialogStaticData.enableWebtrekkIntegration && typeof data != 'undefined' && typeof data.newProduct != 'undefined' && typeof data.newProduct.price != 'undefined') {
            sessionData.transient.priceValue = data.newProduct.price.value;
        }

        productDataCollector.collect(data.oldProduct);
        productDataCollector.collect(data.newProduct);

        // unfortunately we do have to normalize some names from product file to simplify html template reuse
        data.newProduct.texts.emailTextProductOrder = data.newProduct.texts.emailTextProductChangeSummary;
        data.newProduct.hyperlinks.termsOrderLinkDisplayName = data.newProduct.hyperlinks.termsOrderLinkProductChangeDisplayName;
        data.newProduct.hyperlinks.termsOrderLinkUrl = data.newProduct.hyperlinks.termsOrderLinkProductChangeUrl;
        data.newProduct.hyperlinks.rescissionOrderLinkDisplayName = data.newProduct.hyperlinks.rescissionOrderLinkProductChangeDisplayName;
        data.newProduct.hyperlinks.rescissionOrderLinkUrl = data.newProduct.hyperlinks.rescissionOrderLinkProductChangeUrl;

        $scope.confirmation.customerEmail = $scope.confirmation.customerVerificationEmail = (data.newProduct.texts.emailTextProductOrder ? data.customerEmail : null);
        $scope.confirmation.emailVerification = dialogData.emailVerification;

        $scope.updateTeaser(
            data.oldProduct.texts.headerTitleProductChangeSummary,
            data.oldProduct.texts.headerSubTitleProductChangeSummary,
            data.oldProduct.images.headerImageChangeSummaryResourcePath);

        htmlTruster.trust($scope.data.newProduct);
        htmlTruster.trust($scope.data.oldProduct);

        $scope.footnotes = data.newProduct.productDescription.footnotes;

        webtrekk.track('productchange_summary', {
            page_content_id: data.invokingPortal,
            shop_product_name: data.newProduct.texts.productName,
            shop_product_quantity: 1,
            shop_product_sku: $routeParams.newSubscriptionTemplateId,
            shop_product_status: "add"
        });

    }

    // configure routing dialog functions

    $scope.nextClicked = false;

    $scope.actions = {
        next: function() {
            if ($scope.nextClicked)
                return;
            if ($scope.confirmation.failed(
                $scope.data.newProduct.hyperlinks.termsOrderLinkUrl,
                $scope.data.newProduct.hyperlinks.rescissionOrderLinkUrl,
                $scope.data.newProduct.textLists.textToBeConfirmedSummary,
                $scope.data.newProduct.textLists.textToBeConfirmedChangeSummary,
                $scope.data.newProduct.texts.emailTextProductOrder))
                return;

            $scope.nextClicked = true;

            uiservice.productChangeAction({
                    sessionId: sessionData.sessionId,
                    subscriptionTemplateId: $scope.data.oldProduct.subscriptionTemplateId,
                    uniqueSubscriptionId: $scope.data.oldProduct.subscription.uniqueSubscriptionId,
                    newSubscriptionTemplateId: $scope.data.newProduct.subscriptionTemplateId,
                    orderId: $scope.data.orderId,
                    acceptTerms: $scope.confirmation.ok.acceptTerms,
                    acceptRescissionRights: $scope.confirmation.ok.acceptRescissionRights,
                    customerEmail: $scope.confirmation.customerEmail },
                function success(response) {
                    $scope.go("/productchangeconfirmation/"+response.data.newSubscriptionTemplateId+"/"+response.data.newUniqueSubscriptionId);
                },
                $scope.throwServiceResponseFault
            );
        },
        cancel: function() {
            if ($scope.nextClicked)
                return;
            $scope.nextClicked = true;
            $scope.go("/myproducts");
        }
    };

    initDialogData();
}
'use strict';

angular.module('substoreApp.controllers')
    .controller('productdetailsController', ProductdetailsController);

function ProductdetailsController($scope, $routeParams, $translate, dialogData, uiservice, sessionData, productDataCollector, productDataFinalizer, htmlTruster, webtrekk) {

    var subscriptionTemplateId = $routeParams.subscriptionTemplateId;

    sessionData.transient.subscriptionTemplateId = subscriptionTemplateId;

    $scope.isCatalogueActive = true;
    $scope.btn_next_active = false;

    $scope.breadcrumb.init("navigation_catalogue", "#/");

    $scope.hasUndefinedAvailability = productDataFinalizer.hasUndefinedAvailability;
    $scope.hasNoneAvailability = productDataFinalizer.hasNoneAvailability;
    $scope.isAvailable = productDataFinalizer.isAvailable;

    $scope.isDescriptionExpanded = true;
    $scope.isRequirementsExpanded = true;
    $scope.isPriceinformationExpanded = true;
    $scope.isGalleryExpanded = true;
    $scope.isProductGroupExpanded = true;

    function updateNextButton(product) {
        $scope.btn_next_active = product.bookingAllowed;
        $translate([
                'productdetails_btn_order',
                'productdetails_btn_order_complete',
                'productdetails_btn_order_reserved',
                'productdetails_btn_order_alreadybooked',
                'productdetails_btn_order_excludedby',
                'productdetails_btn_order_notallowed',
                'msg_order_currently_not_possible'
            ],
            {excludedBy: product.excludedBy != null && product.excludedBy.length > 0 ? product.excludedBy[0].productName : null})
            .then(function (translations) {
                var translationKey;
                if (product.bookingAllowed)
                    if (product.reservedInstances > 0)
                        translationKey = 'productdetails_btn_order_complete';
                    else
                        translationKey = 'productdetails_btn_order';
                else if (product.canNotSucceed)
                    translationKey = 'msg_order_currently_not_possible';
                else if (product.reservedInstances > 0)
                    translationKey = 'productdetails_btn_order_reserved';
                else if (product.currentInstances >= product.maxInstances)
                    translationKey = 'productdetails_btn_order_alreadybooked';
                else if (product.excludedBy != null && product.excludedBy.length > 0)
                    translationKey = 'productdetails_btn_order_excludedby';
                else
                    translationKey = 'productdetails_btn_order_notallowed';
                $scope.msg_btn_next = translations[translationKey];
            });
    }

    function initDialogData() {
        $scope.data = dialogData;

        var product = dialogData.product;
        productDataCollector.collectWithGallery(product);
        productDataFinalizer.checkAvailability(product);

        $scope.breadcrumb.add(product.texts.productName);

        $scope.updateTeaser(
            product.texts.headerTitleDetails,
            product.texts.headerSubTitleDetails,
            product.images.headerImageDetailsResourcePath);

        htmlTruster.trust($scope.data.product);

        $scope.footnotes = product.productDescription.footnotes;

        updateNextButton(product);

        $scope.selection = {
            ordered: -1,
            subscriptionTemplateId: null,
            productName: product.texts.productName,
            productSubscriptionType: product.texts.productSubscriptionType,
            regularPriceOverrideText: product.texts.regularPriceOverrideText,
            promotionPriceOverrideText: product.texts.promotionPriceOverrideText,
            minimumCommitmentPeriodText: product.texts.minimumCommitmentPeriodText,
            minimumCommitmentPeriodOverrideText: product.texts.minimumCommitmentPeriodOverrideText,
            promotionProcessing: product.promotionProcessing,
            price: product.price,
            members: (product.productGroup ? product.productGroupMembers : [] ),
            init: function () {
                if (product.productGroup) {
                    // assign natural order to members
                    // (currently we do not get some from server)
                    for (var i = 0; i < product.productGroupMembers.length; i++)
                        this.members[i].order = i;
                    if (product.productGroupMembers.length)
                        this.ordered = 0;
                }
            },
            apply: function () {
                // here we do support two selection models:
                // partner features might identify chosen item
                // by order (as of 'natural order') or by
                // subscriptionTemplateId
                var ordered = this.ordered;
                if (ordered === -1 && this.subscriptionTemplateId) {
                    for (var i = 0; i < this.members.length; i++)
                        if (this.subscriptionTemplateId === this.members[i].subscriptionTemplateId) {
                            ordered = i;
                            break;
                        }
                }
                if (ordered >= 0) {
                    var member = this.members[ordered];
                    this.subscriptionTemplateId = member.subscriptionTemplateId;
                    this.productName = member.productName;
                    this.productSubscriptionType = member.productSubscriptionType;
                    this.regularPriceOverrideText = member.regularPriceOverrideText;
                    this.promotionPriceOverrideText = member.promotionPriceOverrideText;
                    this.minimumCommitmentPeriodText = member.minimumCommitmentPeriodText;
                    this.minimumCommitmentPeriodOverrideText = member.minimumCommitmentPeriodOverrideText;
                    this.promotionProcessing = member.promotionProcessing;
                    this.price = member.price;
                    updateNextButton(member);
                } else {
                    this.subscriptionTemplateId = (product.productGroup ? null : product.subscriptionTemplateId);
                    this.productName = product.texts.productName;
                    this.productSubscriptionType = product.texts.productSubscriptionType;
                    this.regularPriceOverrideText = product.texts.regularPriceOverrideText;
                    this.promotionPriceOverrideText = product.texts.promotionPriceOverrideText;
                    this.minimumCommitmentPeriodText = product.texts.minimumCommitmentPeriodText;
                    this.minimumCommitmentPeriodOverrideText = product.texts.minimumCommitmentPeriodOverrideText;
                    this.promotionProcessing = product.promotionProcessing;
                    this.price = product.price;
                    updateNextButton(product);
                }
            },
            partnerFeatureSource: $scope.lookupFeature([$scope.data.partnerName, 'productdetails', 'group'])
        };

        $scope.selection.init();

        $scope.applyFeature($scope, [$scope.data.partnerName, 'productdetails', 'dialog']);

        $scope.selection.apply();

        webtrekk.track('productdetails', {
            shop_product_sku: product.subscriptionTemplateId,
            shop_product_status: "view",
            shop_product_name: product.texts.productName
        });
    }

    // configure routing dialog functions

    $scope.nextClicked = false;

    $scope.next = function () {
        if ($scope.nextClicked)
            return;
        $scope.nextClicked = true;

        var result = $scope.applyFeature($scope, [$scope.data.partnerName, 'productdetails', 'next']);
        // result is either true or false or generic partner data
        if (result) {
            var genericPartnerData = (typeof result === 'object') ? result : null;
            uiservice.productDetailsAction({
                    sessionId: sessionData.sessionId,
                    subscriptionTemplateId: $scope.selection.subscriptionTemplateId,
                    genericPartnerData: genericPartnerData
                },
                function success(response) {
                    $scope.go("/orderselection/" + $scope.selection.subscriptionTemplateId);
                },
                $scope.throwServiceResponseFault
            );
        }
    };

    $scope.galleryClicked = function () {
        webtrekk.track('productdetailsgallery', {
            shop_product_sku: subscriptionTemplateId
        });
    };

    $scope.backAllowed = function () {
        return sessionData.transient.deeplinkedPage !== 'PRODUCTDETAILPAGE';
    };

    $scope.$on("$locationChangeStart",
        function (event, next, current) {
            sessionData.transient.deeplinkedPage = null;
        });

    initDialogData();
}
'use strict';

angular.module('substoreApp.controllers')
    .controller('reservationconfirmationController', ReservationConfirmationController);

function ReservationConfirmationController($scope, $routeParams, dialogData, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_catalogue", "#/");

    $scope.progressBar.reset();

    function initDialogData() {
        var data = $scope.data = dialogData;
        var product = productDataCollector.collect(data.product);

        $scope.breadcrumb.add(product.texts.productName, "#/productdetails/" + $routeParams.subscriptionTemplateId);
        $scope.breadcrumb.add("order");

        $scope.updateTeaser(
            product.texts.headerTitleReservation,
            product.texts.headerSubTitleReservation,
            product.images.headerImageReservationResourcePath);

        $scope.progressBar.setup({
            step: 2,
            isOnlyReservationAllowed: data.isOnlyReservationAllowed
        });

        htmlTruster.trust(data.product);

        $scope.footnotes = product.productDescription.footnotes;

        // page_content_id: product.texts.productName + "-" + $routeParams.subscriptionTemplateId
        webtrekk.track('order_reservation', {
            shop_product_sku: $routeParams.subscriptionTemplateId
        });
    }

    $scope.$on('$routeChangeStart', function(scope, next, current) {
        if ((current.$$route.originalPath === "/reservationconfirmation/:subscriptionTemplateId")
            && next.$$route.originalPath === "/orderselection/:subscriptionTemplateId")
                $scope.go("/productdetails/"+$routeParams.subscriptionTemplateId);
    });

    initDialogData();
}
'use strict';

/* Filters */

angular.module('substoreApp.filters', [])
/** the filter 'i18n' is just a short alias for the filter 'translate' from the angular-translate project */
    .filter('i18n', ['$filter', function ($filter) {
        return $filter('translate');
    }])
    .filter('limitFrom', function() {
        return function(input, start) {
            if (input === undefined || input === null)
                return input;

            return input.slice(+start);
        };
    })
    .filter('translateIntervalUnit', function() {
        return function (input, factor) {
            if (input === undefined || input === null)
                return "";
            input = input.toString();

            if (factor === undefined || input === null)
                factor = 1;
            factor = factor.toString();

            switch (input) {
                case "0" : return "";
                case "1" : return "day"+(factor>1?"s":"");
                case "2" : return "week"+(factor>1?"s":"");
                case "3" : return "month"+(factor>1?"s":"");
                case "5" : return "hour"+(factor>1?"s":"");
                case "6" : return "minute"+(factor>1?"s":"");
                case "12" : return "year"+(factor>1?"s":"");
                default : return input;
            }
        }
    })
    .filter('translateChargingIntervalPrice', ['$filter', function($filter) {
        return function (input) {
            var unit = $filter('translateIntervalUnit')(input);
            if (!unit) return $filter('translate')('price');
            return $filter('translate')('price_label_'+unit);
        }
    }])
    .filter('translateChargingInterval', ['$filter', function($filter) {
        return function (input, factor) {
            if ( factor == 1 ) {
              return $filter('translate')('charging_interval_singular', {unit: $filter('translate')( $filter('translateIntervalUnit')(input, factor) ) } );
            } else {
              return $filter('translate')('charging_interval', {count: factor, unit: $filter('translate')( $filter('translateIntervalUnit')(input, factor) ) } );
            }
        }
    }])
    .filter('translateFromFirstUnit', ['$filter', function($filter) {
        return function (input, suffix) {
            if (!suffix) suffix = "";
            else suffix = '_' + suffix;
            return $filter('translate')('from_first_'+$filter('translateIntervalUnit')(input)+suffix);
        }
    }])
    .filter('translateFirstToXUnit', ['$filter', function($filter) {
        return function (input, factor) {
            return $filter('translate')('first_to_x_'+$filter('translateIntervalUnit')(input), {duration: factor } );
        }
    }])
    .filter('translatePerUnit', ['$filter', function($filter) {
        return function (input) {
            return $filter('translate')('per_unit', {unit: $filter('translate')( $filter('translateIntervalUnit')(input) ) } );
        }
    }])
    .filter('translateFromXUnit', ['$filter', function($filter) {
        return function (input, factor, suffix) {
            if (!suffix) suffix = "";
            else suffix = '_' + suffix;
            return $filter('translate')('from_x_'+$filter('translateIntervalUnit')(input)+suffix, {duration: factor+1 } );
        }
    }])
    .filter('translateWithAlternates', ['$filter', function($filter) {
        return function (input, alternates, additionalArgs) {
            return (alternates && alternates.hasOwnProperty(input)) && alternates[input] || $filter('translate')(input, additionalArgs);
        }
    }]);



'use strict';

angular
    .module('substoreApp')
    .config(configRoutes);

function configRoutes($routeProvider) {
    forwardDefault.$inject = ["$location", "$route", "sessionData"];
    $routeProvider.when('/catalogue', { templateUrl: 'partials/catalogue.html', controller: 'catalogueController', resolve: { dialogData: resolver(getCatalogueData) } });
    $routeProvider.when('/myproducts', { templateUrl: 'partials/myproducts.html', controller: 'myproductsController', resolve: { dialogData: resolver(getMyproductsData) } });
    $routeProvider.when('/myproducts/:subscriptionTemplateId', { templateUrl: 'partials/myproducts.html', controller: 'myproductsController', resolve: { dialogData: resolver(getMyproductsData) } });
    $routeProvider.when('/productdetails/:subscriptionTemplateId', { templateUrl: 'partials/productdetails.html', controller: 'productdetailsController', resolve: { dialogData: resolver(getProductdetailsData) } });
    $routeProvider.when('/orderselection/:subscriptionTemplateId', { templateUrl: 'partials/orderselection.html', controller: 'orderselectionController', resolve: { dialogData: resolver(getOrderselectionData) } });
    $routeProvider.when('/ordersummary/:subscriptionTemplateId/:orderCallId/:mode?', { templateUrl: 'partials/ordersummary.html', controller: 'ordersummaryController', resolve: { dialogData: resolver(getOrdersummaryData) } });
    $routeProvider.when('/orderconfirmation/:subscriptionTemplateId', { templateUrl: 'partials/orderconfirmation.html', controller: 'orderconfirmationController', resolve: { dialogData: resolver(getOrderconfirmationData) } });
    $routeProvider.when('/orderconfirmation/:subscriptionTemplateId/:mode', { templateUrl: 'partials/orderconfirmation.html', controller: 'orderconfirmationController', resolve: { dialogData: resolver(getOrderconfirmationData) } });
    $routeProvider.when('/reservationconfirmation/:subscriptionTemplateId', { templateUrl: 'partials/reservationconfirmation.html', controller: 'reservationconfirmationController', resolve: { dialogData: resolver(getReservationconfirmationData) } });
    $routeProvider.when('/productchangeselection/:subscriptionTemplateId/:uniqueSubscriptionId', { templateUrl: 'partials/productchangeselection.html', controller: 'productchangeselectionController', resolve: { dialogData: resolver(getProductchangeselectionData) } });
    $routeProvider.when('/productchangesummary/:subscriptionTemplateId/:uniqueSubscriptionId/:newSubscriptionTemplateId', { templateUrl: 'partials/productchangesummary.html', controller: 'productchangesummaryController', resolve: { dialogData: resolver(getProductchangesummaryData) } });
    $routeProvider.when('/productchangeconfirmation/:subscriptionTemplateId/:uniqueSubscriptionId', { templateUrl: 'partials/productchangeconfirmation.html', controller: 'productchangeconfirmationController', resolve: { dialogData: resolver(getProductchangeconfirmationData) } });
    $routeProvider.when('/orderadministrationselection/:subscriptionTemplateId/:uniqueSubscriptionId', { templateUrl: 'partials/orderadministrationselection.html', controller: 'orderadministrationselectionController', resolve: { dialogData: resolver(getOrderadministrationselectionData) } });
    $routeProvider.when('/orderadministrationselection/:subscriptionTemplateId/:uniqueSubscriptionId/:requestedParameterValue', { templateUrl: 'partials/orderadministrationselection.html', controller: 'orderadministrationselectionController', resolve: { dialogData: resolver(getOrderadministrationselectionData) } });
    $routeProvider.when('/orderadministrationsummary/:subscriptionTemplateId/:uniqueSubscriptionId/:requestedParameterValue', { templateUrl: 'partials/orderadministrationsummary.html', controller: 'orderadministrationsummaryController', resolve: { dialogData: resolver(getOrderadministrationsummaryData) } });
    $routeProvider.when('/orderadministrationconfirmation/:subscriptionTemplateId/:uniqueSubscriptionId', { templateUrl: 'partials/orderadministrationconfirmation.html', controller: 'orderadministrationconfirmationController', resolve: { dialogData: resolver(getOrderadministrationconfirmationData) } });
    $routeProvider.when('/processing', { templateUrl: 'partials/processing.html' });
    $routeProvider.when('/error', { templateUrl: 'partials/error.html' });
    $routeProvider.when('/error/:code', { templateUrl: 'partials/error.html' });
    $routeProvider.when('/logout', { templateUrl: 'partials/logout.html' });
    $routeProvider.when('/logout/:redirectTo', { templateUrl: 'partials/logout.html' });
    $routeProvider.when('/', { resolve: { load: forwardDefault }});
    $routeProvider.otherwise({ redirectTo: '/error/INVALID_URL' });

    // redirect to either catalogue or myproducts, if we have a session and are allowed to

    function forwardDefault($location, $route, sessionData) {
        sessionData.promise.then(function() {
            // only handle if we do not have a fault. If we have a fault, this has been handled below in run()
            if (!sessionData.hasFault()) {
                // we might have been run into a race condition:
                // if "/" did come with a cryptoticket having routing arguments (e.g. like '&page=...')
                // then we were already routed away on behalf of initial ui service invocation. So
                // we do check location again and if changed then we silently ignore this case
                if ($location.path() !== "/")
                    return;

                // the parameter 'action' is set if we're coming from a 3rd party authentication page
                var action = $route.current.params.action;
                if (sessionData.dialogStaticData.showCatalogue && (!action || action == 'catalogue')) {
                    $location.path("/catalogue");
                } else if (sessionData.dialogStaticData.showMyProducts && (!action || action == 'myproducts')) {
                    $location.path("/myproducts");
                } else if (action == 'ordersummary') {
                    // parameter 'action' has been given (we're coming from a 3rd party authentication page); go directly to ordersummary page
                    $location.url('/ordersummary/' + sessionData.transient.subscriptionTemplateId + '/' + sessionData.transient.orderCallId);
                } else {
                    throw { code: "ACCESS_DENIED" };
                }
            }
        });
        return sessionData.promise;
    }

    // dependency resolving functions

    function getCatalogueData(sessionData, uiservice) {
        return uiservice.catalogueDialogData({
            sessionId: sessionData.sessionId
        });
    }

    function getMyproductsData(sessionData, uiservice) {
        return uiservice.myProductsOverviewDialogData({
            sessionId: sessionData.sessionId,
            msisdn: sessionData.dialogStaticData.msisdn
        });
    }

    function getProductdetailsData(sessionData, uiservice, $route) {
        return uiservice.productDetailsDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId
        });
    }

    function getOrderselectionData(sessionData, uiservice, $route) {
        var subscriptionTemplateId = sessionData.transient.subscriptionTemplateId = $route.current.params.subscriptionTemplateId;
        sessionData.transient.orderCallId = $route.current.params.orderCallId;

        return uiservice.orderSelectionDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: subscriptionTemplateId
        });
    }

    function getOrdersummaryData(sessionData, uiservice, $route) {
        var subscriptionTemplateId = sessionData.transient.subscriptionTemplateId = $route.current.params.subscriptionTemplateId;
        var orderCallId = sessionData.transient.orderCallId = $route.current.params.orderCallId;
        var optin = $route.current.params.mode === "optin" ? true : undefined;

        return uiservice.orderSummaryDialogData({
            sessionId: sessionData.sessionId,
            orderCallId: orderCallId,
            subscriptionTemplateId: subscriptionTemplateId,
            optin: optin
        });
    }

    function getOrderconfirmationData(sessionData, uiservice, $route) {
        var subscriptionTemplateId = sessionData.transient.subscriptionTemplateId = $route.current.params.subscriptionTemplateId;
        var mode = { optin: ($route.current.params.mode === "optin") ? true : undefined };
        var confirmationInProgress = $route.current.params.mode === 'inProgress';

        return uiservice.orderConfirmationDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: subscriptionTemplateId,
            optin: mode.optin,
            confirmationInProgress: confirmationInProgress
        });
    }

    function getReservationconfirmationData(sessionData, uiservice, $route) {
        return uiservice.reservationConfirmationDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId
        });
    }

    function getProductchangeselectionData(sessionData, uiservice, $route) {
        return uiservice.productChangeSelectionDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId
        });
    }

    function getProductchangesummaryData(sessionData, uiservice, $route) {
        return uiservice.productChangeSummaryDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId,
            newSubscriptionTemplateId: $route.current.params.newSubscriptionTemplateId
        });
    }

    function getProductchangeconfirmationData(sessionData, uiservice, $route) {
        return uiservice.productChangeConfirmationDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId
        });
    }

    function getOrderadministrationselectionData(sessionData, uiservice, $route) {
        return uiservice.orderAdministrationDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId});
    }

    function getOrderadministrationsummaryData(sessionData, uiservice, $route) {
        return uiservice.orderAdministrationSummaryDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId,
            requestedParameterValue: $route.current.params.requestedParameterValue
        });
    }

    function getOrderadministrationconfirmationData(sessionData, uiservice, $route) {
        return uiservice.orderAdministrationConfirmationDialogData({
            sessionId: sessionData.sessionId,
            subscriptionTemplateId: $route.current.params.subscriptionTemplateId,
            uniqueSubscriptionId: $route.current.params.uniqueSubscriptionId
        });
    }

    // it would be awkward to implement awaiting promises for session data, extracting response results as well as
    // handling errors for each dependency resolving function, so we do 'curry' it with the following resolver() function

    function resolver(dependencyFn) {
        return function (sessionData, uiservice, throwServiceResponseFault, $route) {
            return sessionData.promise.then(
                function () {
                    // CAUTH-312: if browser recovers after connection error, there
                    // is not a real error handling established, which may clear most
                    // recent error if user continues navigation. So we wipe it out here
                    sessionData.resetFault();

                    return dependencyFn.call(this, sessionData, uiservice, $route);
                }).then(
                function (resource) {
                    return resource.$promise.then(
                        function (result) {
                            return result.data;
                        }).catch(throwServiceResponseFault);
                });
        }
    }
}
angular.module('substoreApp')

    .factory('uipartnerserviceAce', ['$resource', function ($resource) {
        return $resource('../../uiservice/ace/:methodName?t=:cacheSlayer',
            {
                cacheSlayer: function () {
                    return (new Date().getTime() + Math.random()).toString(16);
                }
            },
            {
                productConfigurations: {method: 'GET', params: {methodName: 'productConfigurations'}}
            }
        );
    }])

    .service('partnerFeatureAce', [ "sessionData", "uipartnerserviceAce", function (sessionData, uipartnerserviceAce) {

        return {
            templates: {
                productdetails: { group: "partner/ace/templates/productdetailsgroup.html" }
            },
            actions: {
                productdetails: {
                    dialog: function (scope) {
                        scope.selection.ordered = -1; // we do not want preselection
                        scope.selection.apply();

                        scope.ace = {
                            priceList: null,
                            paymentIntervalNames: {},
                            options: {
                                manufacturers: null,
                                devices: null,
                                insuranceClasses: null,
                                paymentIntervals: null
                            },
                            selection: {
                                manufacturerName: "",
                                deviceId: "",
                                insuranceClassId: "",
                                paymentInterval: "",
                                tariff: null
                            },
                            maps: {
                                manufacturers: { },
                                devices: { },
                                insuranceClasses: { }
                            },
                            getPaymentIntervalName: function (value) {
                                return this.paymentIntervalNames[value];
                            },
                            applyFilter: function (kind) {
                                // reset lists as predefined
                                switch (kind) {
                                    case "manufacturers":
                                        if (this.selection.manufacturerName)
                                            this.options.devices = this.maps.manufacturers[this.selection.manufacturerName].deviceList.device;
                                        else
                                            this.options.devices = null;
                                        this.selection.deviceId = "";
                                    // fallthrough intended
                                    case "devices":
                                        this.options.insuranceClasses = null;
                                        this.selection.insuranceClassId = "";
                                    // fallthrough intended
                                    case "insuranceClasses":
                                        this.options.paymentIntervals = null;
                                        this.selection.paymentInterval = "";
                                }

                                // calculate selection options and determine actual tariff
                                var tariffs = [ ];
                                this.selection.tariff = null;

                                if (this.selection.deviceId) {
                                    // calculate eligible tariffs depending on actual selection
                                    var device = this.selection.deviceId && this.maps.devices[this.selection.deviceId];
                                    if (device)
                                        for (var i = 0; i < this.priceList.tariff.length; i++) {
                                            var tariff = this.priceList.tariff[i];
                                            if (tariff.deviceClassId === device.deviceClassId)
                                                tariffs.push(tariff);
                                        }

                                    // derive unique lists from eligible tariffs into options
                                    var insuranceClasses = this.options.insuranceClasses = [];
                                    var paymentIntervals = this.options.paymentIntervals = [];

                                    for (var i = 0; i < tariffs.length; i++) {
                                        var tariff = tariffs[i];

                                        var insuranceClass = this.maps.insuranceClasses[tariff.insuranceClassId];
                                        if (insuranceClasses.indexOf(insuranceClass) < 0)
                                            insuranceClasses.push(insuranceClass);

                                        if (this.selection.insuranceClassId
                                            && (paymentIntervals.indexOf(tariff.paymentInterval) < 0)
                                            && (tariff.insuranceClassId === this.selection.insuranceClassId || !this.selection.insuranceClassId))
                                            paymentIntervals.push(tariff.paymentInterval);

                                        if (tariff.insuranceClassId === this.selection.insuranceClassId && tariff.paymentInterval === this.selection.paymentInterval)
                                            this.selection.tariff = tariff;
                                    }
                                }

                                // propagate selection to visible fields
                                scope.selection.subscriptionTemplateId = (this.selection.tariff ? this.selection.tariff.tariffId : null);
                                scope.selection.apply();
                            }
                        };

                        uipartnerserviceAce.productConfigurations({sessionId: sessionData.sessionId},
                            function success(response) {
                                var priceList = response.data.priceList;
                                if (!priceList)
                                    throw "illegal state: ACE uiservice did not return any pricelist";

                                scope.ace.priceList = priceList;

                                scope.ace.paymentIntervalNames = response.data.paymentIntervalNames;

                                // prepare data as required
                                scope.ace.options.manufacturers = [ ];

                                var manufacturers = scope.ace.priceList.manufacturer;
                                for (var i = 0; i < manufacturers.length; i++) {
                                    var manufacturer = manufacturers[i];
                                    scope.ace.maps.manufacturers[manufacturer.manufacturerName] = manufacturer;
                                    scope.ace.options.manufacturers.push(manufacturer);

                                    for (var j = 0; j < manufacturer.deviceList.device.length; j++) {
                                        var device = manufacturer.deviceList.device[j];

                                        scope.ace.maps.devices[device.deviceId] = device;
                                    }
                                }

                                var insurancesClasses = scope.ace.priceList.insuranceClass;
                                for (var i = 0; i < insurancesClasses.length; i++)
                                    scope.ace.maps.insuranceClasses[insurancesClasses[i].id] = insurancesClasses[i];
                            },
                            scope.throwServiceResponseFault
                        );
                    },
                    next: function (scope) {
                        return [
                            { key: 'Partner.manufacturerName', value: scope.ace.selection.manufacturerName },
                            { key: 'Partner.modelName', value: scope.ace.maps.devices[scope.ace.selection.deviceId].modelName },
                            { key: 'Partner.deviceID', value: scope.ace.maps.devices[scope.ace.selection.deviceId].deviceId },
                            { key: 'Partner.deviceClassId', value: scope.ace.selection.tariff.deviceClassId },
                            { key: 'Partner.tariffId', value: scope.ace.selection.tariff.tariffId },
                            { key: 'Partner.insuranceClassId', value: scope.ace.selection.insuranceClassId },
                            { key: 'Partner.paymentInterval', value: scope.ace.selection.paymentInterval }
                        ];
                    }
                },
                orderselection: {
                    dialog: function (scope) {
                        scope.ace = { acceptTransfer: false };

                        scope.data.product.exemptedFromTax = 1; // with insurances we do not have vat (but insurance tax)
                    }
                }
            }

        }
    }]);

angular.module('substoreApp')

    .service('partnerFeatureWeb2t', [ '$log', function ($log) {

        var blackList2 = {
            "01": true,
            "32": true
        };

        var blackList3 = {
            "310": true,
            "311": true,
            "32": true,
            "500": true,
            "501": true,
            "601": true,
            "700": true,
            "701": true,
            "800": true,
            "801": true,
            "900": true,
            "901": true,
            "902": true,
            "903": true,
            "904": true,
            "905": true
        };

        function formatFixedLineNumber(value) {
            if (!value)
                return value;

            value = value.replace(/ /g, "");

            if (value.match(/^\+49/))
                return value;

            if (value.match(/^49/))
                return "+49".concat(value.substr(2));

            if (value.match(/^0049/))
                return "+49".concat(value.substr(4));

            if (value.match(/^0/))
                return "+49".concat(value.substr(1));

            return "+49".concat(value);
        }

        function hasValidFormat(value) {
            if (!value)
                return false;

            if (!value.match(/^\+49[2-9][0-9]{1,16}$/))
                return false;

            if (blackList2.hasOwnProperty(value.substr(3, 2)))
                return false;

            if (blackList3.hasOwnProperty(value.substr(3, 3)))
                return false;

            return true;
        }

        function prepareProductDetails(scope) {
            var product = scope.data.product;
            if (product.bookingAllowed && product.reservedInstances > 0)
                product.overrideOrderButtonText = 'product_order_in_progress';
        }

        function validateFixedLineNumber(scope) {
            var fixedLineNumber = formatFixedLineNumber(scope.confirmation.requestedParameterValue);
            var isValid = hasValidFormat(fixedLineNumber);
            //$log.debug("fixedLineNumber: " + fixedLineNumber + " ==> " + isValid);
            if (isValid)
                scope.confirmation.requestedParameterValue = fixedLineNumber;
            else
                scope.confirmation.faultStates = {
                    fixedLineNumber: [ "orderselection_msg_fixedlinenumber_invalid" ]
                };

            return isValid;
        }

        function validateFixedLineNumberForOrderAdministration(scope) {
            var isValid = validateFixedLineNumber(scope);

            if (isValid)
                if (scope.confirmation.requestedParameterValue == scope.data.currentParameterValue) {
                    isValid = false;

                    scope.confirmation.faultStates = {
                        fixedLineNumber: ["orderselection_msg_fixedlinenumber_is_current"]
                    };
                }

            return isValid;
        }

        return {
            templates: {
                orderselection: { option: "partner/web2t/templates/orderselectionoption.html" },
                orderadministrationselection: { option: "partner/web2t/templates/orderselectionoption.html" }
            },
            actions: {
                productdetails: { dialog: prepareProductDetails },
                orderselection: { validation: validateFixedLineNumber },
                orderadministrationselection: { validation: validateFixedLineNumberForOrderAdministration }
            }
        };
    }]);